import toast from "react-hot-toast";
import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../Services/api";
import { useAuth } from "../Contexts/AuthContext";
import * as XLSX from 'xlsx';
import "../styles/leads.css";

const STATUS_CFG = {
  New: { bg: "#e8f4fd", color: "#2a85c7", dot: "#3b9edd" },
  Contacted: { bg: "#fff8e6", color: "#c47f0a", dot: "#e6a817" },
  Interested: { bg: "#f0fdf4", color: "#166534", dot: "#22c55e" },
  "Form Filled": { bg: "#edf7ee", color: "#2a7a38", dot: "#36a849" },
  "Admission Done": { bg: "#f3e8ff", color: "#7c3aed", dot: "#9333ea" },
  Pipeline: { bg: "#f0fdfa", color: "#0d9488", dot: "#14b8a6" },
  Lost: { bg: "#fef2f2", color: "#c0392b", dot: "#e05c5c" },
  "Course Not Available": { bg: "#f5f3ff", color: "#5b21b6", dot: "#8b5cf6" },
  "Will Think On It": { bg: "#eff6ff", color: "#1e40af", dot: "#3b82f6" },
  "Missed": { bg: "#fef2f2", color: "#ef4444", dot: "#ef4444" },
  "Upcoming Today": { bg: "#fef3c7", color: "#d97706", dot: "#f59e0b" },
  "Upcoming Later": { bg: "#faf5ff", color: "#7c3aed", dot: "#a855f7" },
};

const AVATAR_COLORS = [
  ["#e8f4fd", "#2a85c7"], ["#edf7ee", "#2a7a38"], ["#f2f7e4", "#4a6508"],
  ["#fff8e6", "#c47f0a"], ["#fef2f2", "#c0392b"], ["#f3e8ff", "#7c3aed"],
];

const ALL_STATUSES = ["All", "New", "Contacted", "Interested", "Form Filled", "Admission Done", "Pipeline", "Lost", "Course Not Available", "Will Think On It", "Missed", "Upcoming Today", "Upcoming Later"];
const SUB_STATUS_OPTIONS = [
  "Back Date Admissions",
  "Call Back Later",
  "Call Back Tomorrow",
  "Call Disconnected",
  "Consultancy",
  "Course Not Available",
  "Distance Issue",
  "Form Filled",
  "Financial Issue",
  "Incoming Not Available",
  "Interested",
  "Invalid",
  "Language Issue",
  "Next Session",
  "Not Connected",
  "Not Eligible",
  "Not Interested",
  "Out of Service",
  "Ringing / No Answer",
  "Seat Full",
  "Switch Off",
  "Unreachable",
  "Will Think On It",
  "Wrong Enquiry",
  "Wrong Number",
  "Other"
];

const SUB_STATUS_CFG = {
  "Not Connected": { bg: "#fef2f2", color: "#991b1b", border: "#fee2e2" },
  "Unreachable": { bg: "#fef2f2", color: "#991b1b", border: "#fee2e2" },
  "Switch Off": { bg: "#fef2f2", color: "#991b1b", border: "#fee2e2" },
  "Wrong Number": { bg: "#fff1f2", color: "#9f1239", border: "#ffe4e6" },
  "Out of Service": { bg: "#fff1f2", color: "#9f1239", border: "#ffe4e6" },
  "Invalid": { bg: "#fef2f2", color: "#b91c1c", border: "#fee2e2" },
  "Wrong Enquiry": { bg: "#fff1f2", color: "#9f1239", border: "#ffe4e6" },
  "Seat Full": { bg: "#fff1f2", color: "#9f1239", border: "#ffe4e6" },
  "Incoming Not Available": { bg: "#fef2f2", color: "#991b1b", border: "#fee2e2" },
  "Call Disconnected": { bg: "#fef2f2", color: "#991b1b", border: "#fee2e2" },

  "Not Interested": { bg: "#f8fafc", color: "#475569", border: "#e2e8f0" },
  "Distance Issue": { bg: "#f8fafc", color: "#475569", border: "#e2e8f0" },
  "Language Issue": { bg: "#f8fafc", color: "#475569", border: "#e2e8f0" },

  "Ringing / No Answer": { bg: "#fffbeb", color: "#92400e", border: "#fef3c7" },
  "Call Back Later": { bg: "#fffbeb", color: "#92400e", border: "#fef3c7" },
  "Call Back Tomorrow": { bg: "#fffbeb", color: "#92400e", border: "#fef3c7" },
  "Next Session": { bg: "#fffbeb", color: "#b45309", border: "#fef3c7" },

  "Interested": { bg: "#f0fdf4", color: "#166534", border: "#dcfce7" },
  "Consultancy": { bg: "#f0fdf4", color: "#166534", border: "#dcfce7" },

  "Admission Done": { bg: "#ecfdf5", color: "#065f46", border: "#d1fae5" },
  "Form Filled": { bg: "#edf7ee", color: "#2a7a38", border: "#36a849" },
  "Back Date Admissions": { bg: "#ecfdf5", color: "#065f46", border: "#d1fae5" },

  "Course Not Available": { bg: "#f5f3ff", color: "#5b21b6", border: "#ede9fe" },
  "Will Think On It": { bg: "#eff6ff", color: "#1e40af", border: "#dbeafe" },
  "Not Eligible": { bg: "#f8fafc", color: "#475569", border: "#e2e8f0" },

  "Other": { bg: "#f8fafc", color: "#475569", border: "#e2e8f0" },
};
// Clean formal SVG Icons to replace emojis
function IconUser() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>; }
function IconGraduation() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" /></svg>; }
function IconBuilding() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2" /><line x1="9" y1="22" x2="9" y2="16" /><line x1="15" y1="22" x2="15" y2="16" /><path d="M9 16h6v6H9z" /><path d="M8 6h.01M16 6h.01M8 11h.01M16 11h.01" /></svg>; }
function IconTag() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01" /></svg>; }
function IconGlobe() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>; }
function IconHandshake() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7.5" /><path d="M16 14l2-2 4 4-6 6-3-3" /></svg>; }
function IconPhone() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>; }
function IconSmartphone() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><line x1="12" y1="18" x2="12.01" y2="18" /></svg>; }
function IconMail() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>; }
function IconWalk() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="1" /><path d="M12 7a1 1 0 0 1 1 1v3h3.5a.5.5 0 0 1 .4.8l-3.5 5.25a.5.5 0 0 1-.8-.3l-.8-2.4-2.8 1.4a.5.5 0 0 1-.6-.2l-2-3a.5.5 0 0 1 .8-.6l1.6 2.4 2.2-1.1v-6.5a1 1 0 0 1 1-1z" /></svg>; }
function IconStar() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>; }
function IconAlert({ size = 13, style = {} }) { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px', ...style }} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>; }
function IconFolder({ size = 18, style = {} }) { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" /></svg>; }
function IconChart() { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '6px' }} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>; }

const SOURCE_OPTIONS = [
  { name: "Website", icon: <IconGlobe />, color: "#3b82f6" },
  { name: "Referral", icon: <IconHandshake />, color: "#10b981" },
  { name: "Cold Call", icon: <IconPhone />, color: "#f59e0b" },
  { name: "Social Media", icon: <IconSmartphone />, color: "#ef4444" },
  { name: "Email", icon: <IconMail />, color: "#a855f7" },
  { name: "Walk-in", icon: <IconWalk />, color: "#84cc16" },
  { name: "Other", icon: <IconStar />, color: "#6366f1" }
];
const EMPTY_FORM = {
  name: "",
  email: "",
  phone: "",
  company: "",
  status: "New",
  sub_status: "",
  custom_sub_status: "",
  course: "",
  state: "",
  district: "",
  notes: "",
  source: "Website",
  assigned_to: null,
  lead_type: null,
  alternate_contacts: []
};

const fmtValue = (v) => v || "—";
const initials = (n) => n.trim().split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() || "?";
const todayLbl = () => new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
const localISO = () => {
  const d = new Date();
  const offset = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - offset).toISOString().slice(0, 16);
};

const isTodayFuture = (dateStr) => {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  const now = new Date();
  return d.getFullYear() === now.getFullYear() &&
         d.getMonth() === now.getMonth() &&
         d.getDate() === now.getDate() &&
         d > now;
};


/**
 * FormFields defined outside for stability
 */
const FormFields = ({ form, setForm, errors, setErrors, leadTypes, setLeadTypes, sourceOptions = SOURCE_OPTIONS }) => (
  <div className="ld-modal-body">
    {errors.detail && <div className="ld-api-error-banner">{errors.detail}</div>}
    {errors.non_field_errors && <div className="ld-api-error-banner">{errors.non_field_errors[0]}</div>}
    <div className="ld-form-row">
      <div className="ld-form-field">
        <label className="ld-form-label">Full Name <span className="req">*</span></label>
        <input
          data-field="name"
          className={`ld-form-input${errors.name ? " error" : ""}`}
          placeholder="e.g. Rahul Mehta"
          value={form.name}
          onChange={e => { setForm({ ...form, name: e.target.value }); setErrors({ ...errors, name: "" }); }}
        />
        {errors.name && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.name) ? errors.name[0] : errors.name}</span>}
      </div>
      <div className="ld-form-field">
        <label className="ld-form-label">University</label>
        <input
          data-field="company"
          className={`ld-form-input${errors.company ? " error" : ""}`}
          placeholder="e.g. Delhi University or IT Kalka"
          value={form.company}
          onChange={e => { setForm({ ...form, company: e.target.value }); setErrors({ ...errors, company: "" }); }}
        />
        {errors.company && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.company) ? errors.company[0] : errors.company}</span>}
      </div>
    </div>
    <div className="ld-form-row">
      <div className="ld-form-field">
        <label className="ld-form-label">Email</label>
        <input
          data-field="email"
          className={`ld-form-input${errors.email ? " error" : ""}`}
          type="email"
          placeholder="email@university.edu"
          value={form.email}
          onChange={e => { setForm({ ...form, email: e.target.value }); setErrors({ ...errors, email: "" }); }}
        />
        {errors.email && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.email) ? errors.email[0] : errors.email}</span>}
      </div>
      <div className="ld-form-field">
        <label className="ld-form-label">Phone <span className="req">*</span></label>
        <input
          data-field="phone"
          className={`ld-form-input${errors.phone ? " error" : ""}`}
          placeholder="+91 98765 43210"
          value={form.phone}
          onChange={e => { setForm({ ...form, phone: e.target.value.replace(/\D/g, '') }); setErrors({ ...errors, phone: "" }); }}
          onKeyPress={e => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}
        />
        {errors.phone && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.phone) ? errors.phone[0] : errors.phone}</span>}
      </div>
    </div>
    <div className="ld-form-row">
      <div className="ld-form-field">
        <label className="ld-form-label">Status</label>
        <div className="ld-status-picker">
          {Object.keys(STATUS_CFG).filter(s => s !== "Upcoming Today" && s !== "Upcoming Later").map(s => (
            <button
              key={s}
              type="button"
              className={`ld-status-opt${form.status === s ? " sel" : ""}`}
              style={form.status === s ? { background: STATUS_CFG[s].bg, color: STATUS_CFG[s].color, borderColor: STATUS_CFG[s].dot } : {}}
              onClick={() => setForm({ ...form, status: s })}
            >
              <div className="ld-status-opt-dot" style={{ background: STATUS_CFG[s].dot }} />
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
    <div className="ld-form-row">
      <div className="ld-form-field">
        <label className="ld-form-label">Sub Status</label>
        <select
          data-field="sub_status"
          className="ld-form-input"
          value={form.sub_status}
          onChange={e => setForm({ ...form, sub_status: e.target.value })}
        >
          <option value="">Select sub status...</option>
          {SUB_STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
        {form.sub_status === "Other" && (
          <input
            data-field="custom_sub_status"
            className="ld-form-input"
            style={{ marginTop: '8px' }}
            placeholder="Type custom sub status..."
            value={form.custom_sub_status}
            onChange={e => setForm({ ...form, custom_sub_status: e.target.value })}
          />
        )}
      </div>
      <div className="ld-form-field">
        <label className="ld-form-label">Course</label>
        <input
          data-field="course"
          className={`ld-form-input${errors.course ? " error" : ""}`}
          placeholder="e.g. BCA, MBA, B.Tech"
          value={form.course}
          onChange={e => { setForm({ ...form, course: e.target.value }); setErrors({ ...errors, course: "" }); }}
        />
        {errors.course && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.course) ? errors.course[0] : errors.course}</span>}
      </div>
    </div>
    <div className="ld-form-row">
      <div className="ld-form-field">
        <label className="ld-form-label">State</label>
        <input
          data-field="state"
          className={`ld-form-input${errors.state ? " error" : ""}`}
          placeholder="e.g. Maharashtra"
          value={form.state}
          onChange={e => { setForm({ ...form, state: e.target.value }); setErrors({ ...errors, state: "" }); }}
        />
        {errors.state && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.state) ? errors.state[0] : errors.state}</span>}
      </div>
      <div className="ld-form-field">
        <label className="ld-form-label">District</label>
        <input
          data-field="district"
          className={`ld-form-input${errors.district ? " error" : ""}`}
          placeholder="e.g. Pune"
          value={form.district}
          onChange={e => { setForm({ ...form, district: e.target.value }); setErrors({ ...errors, district: "" }); }}
        />
        {errors.district && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px' }}>{Array.isArray(errors.district) ? errors.district[0] : errors.district}</span>}
      </div>
    </div>
    <div className="ld-form-field">
      <label className="ld-form-label">Lead Source</label>
      <div className="ld-source-picker">
        {sourceOptions.map(opt => (
          <button
            key={opt.name}
            type="button"
            className={`ld-source-opt${form.source === opt.name ? " sel" : ""}`}
            style={form.source === opt.name ? { background: opt.color + "15", color: opt.color, borderColor: opt.color } : {}}
            onClick={() => setForm({ ...form, source: opt.name })}
          >
            <span>{opt.icon}</span> {opt.name}
          </button>
        ))}
      </div>
    </div>
    <div className="ld-form-field">
      <label className="ld-form-label">Lead Type</label>
      <div style={{ display: 'flex', gap: '8px' }}>
        <select
          data-field="lead_type"
          className="ld-form-input"
          style={{ flex: 1 }}
          value={form.lead_type || ""}
          onChange={e => setForm({ ...form, lead_type: e.target.value || null })}
        >
          <option value="">Select lead type...</option>
          {leadTypes.map(lt => <option key={lt.id} value={lt.id}>{lt.name}</option>)}
        </select>
        <button
          type="button"
          className="ld-add-btn"
          style={{ padding: '0 12px', height: '38px', minWidth: 'auto' }}
          title="Add New Lead Type"
          onClick={async () => {
            const name = prompt("Enter new lead type name (e.g. Meta, Referral):");
            if (name) {
              try {
                const res = await api.post('crm/lead-types/', { name });
                setLeadTypes(prev => [...prev, res.data]);
                setForm(prev => ({ ...prev, lead_type: res.data.id }));
                toast.success("Lead type added");
              } catch (err) { toast.error("Failed to add lead type"); }
            }
          }}
        >
          +
        </button>
      </div>
    </div>
    <div className="ld-form-field">
      <label className="ld-form-label">Notes</label>
      <textarea
        data-field="notes"
        className="ld-form-input ld-textarea"
        placeholder="Add notes about this lead…"
        rows={3}
        value={form.notes}
        onChange={e => setForm({ ...form, notes: e.target.value })}
      />
    </div>

    {/* Alternate Contacts Section */}
    <div className="ld-form-field" style={{ marginTop: '16px', borderTop: '1px solid var(--border, #cbd5e1)', paddingTop: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <label className="ld-form-label" style={{ margin: 0, fontWeight: 600 }}>Alternate Contacts</label>
        <button
          type="button"
          className="ld-add-btn"
          style={{ padding: '4px 10px', fontSize: '12px', height: 'auto', minWidth: 'auto' }}
          onClick={() => {
            const currentAlts = form.alternate_contacts || [];
            setForm({
              ...form,
              alternate_contacts: [...currentAlts, { phone: "", email: "", guardian_name: "" }]
            });
          }}
        >
          + Add Alternate Contact
        </button>
      </div>

      {(form.alternate_contacts || []).map((alt, index) => {
        const altErrors = (errors.alternate_contacts && errors.alternate_contacts[index]) || {};
        return (
          <div key={index} className="ld-alternate-contact-row" style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'flex-start', background: '#f8fafc', padding: '8px', borderRadius: '4px', border: '1px solid #e2e8f0', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <input
                  data-field={`alt_phone_${index}`}
                  className={`ld-form-input${altErrors.phone ? " error" : ""}`}
                  style={{ height: '32px', fontSize: '13px' }}
                  placeholder="Alt Phone"
                  value={alt.phone}
                  onChange={e => {
                    const updated = [...form.alternate_contacts];
                    updated[index].phone = e.target.value.replace(/\D/g, '');
                    setForm({ ...form, alternate_contacts: updated });
                    if (errors.alternate_contacts) {
                      const newAltErrors = [...errors.alternate_contacts];
                      if (newAltErrors[index]) newAltErrors[index].phone = "";
                      setErrors({ ...errors, alternate_contacts: newAltErrors });
                    }
                  }}
                  onKeyPress={e => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}
                />
                {altErrors.phone && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px', fontSize: '11px' }}>{Array.isArray(altErrors.phone) ? altErrors.phone[0] : altErrors.phone}</span>}
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <input
                  data-field={`alt_email_${index}`}
                  className={`ld-form-input${altErrors.email ? " error" : ""}`}
                  style={{ height: '32px', fontSize: '13px' }}
                  placeholder="Alt Email"
                  type="email"
                  value={alt.email}
                  onChange={e => {
                    const updated = [...form.alternate_contacts];
                    updated[index].email = e.target.value;
                    setForm({ ...form, alternate_contacts: updated });
                    if (errors.alternate_contacts) {
                      const newAltErrors = [...errors.alternate_contacts];
                      if (newAltErrors[index]) newAltErrors[index].email = "";
                      setErrors({ ...errors, alternate_contacts: newAltErrors });
                    }
                  }}
                />
                {altErrors.email && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px', fontSize: '11px' }}>{Array.isArray(altErrors.email) ? altErrors.email[0] : altErrors.email}</span>}
              </div>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <input
                  data-field={`alt_guardian_${index}`}
                  className={`ld-form-input${altErrors.guardian_name ? " error" : ""}`}
                  style={{ height: '32px', fontSize: '13px' }}
                  placeholder="Guardian Name"
                  value={alt.guardian_name}
                  onChange={e => {
                    const updated = [...form.alternate_contacts];
                    updated[index].guardian_name = e.target.value;
                    setForm({ ...form, alternate_contacts: updated });
                    if (errors.alternate_contacts) {
                      const newAltErrors = [...errors.alternate_contacts];
                      if (newAltErrors[index]) newAltErrors[index].guardian_name = "";
                      setErrors({ ...errors, alternate_contacts: newAltErrors });
                    }
                  }}
                />
                {altErrors.guardian_name && <span className="ld-form-error" style={{ display: 'block', marginTop: '4px', fontSize: '11px' }}>{Array.isArray(altErrors.guardian_name) ? altErrors.guardian_name[0] : altErrors.guardian_name}</span>}
              </div>
              <button
                type="button"
                className="ld-delete-btn"
                style={{ padding: '0 8px', height: '32px', minWidth: 'auto', background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5', borderRadius: '4px', cursor: 'pointer' }}
                onClick={() => {
                  const updated = form.alternate_contacts.filter((_, idx) => idx !== index);
                  setForm({ ...form, alternate_contacts: updated });
                }}
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default function Leads() {
  const { user: me } = useAuth();

  const canAdd = me?.all_permissions?.includes("add_leads") || me?.is_superuser;
  const canEdit = me?.all_permissions?.includes("edit_leads") || me?.is_superuser;
  const canDelete = me?.all_permissions?.includes("delete_leads") || me?.is_superuser;
  const canAssign = me?.all_permissions?.includes("assign_leads") || me?.all_permissions?.includes("manage_leads") || me?.is_superuser;
  const canViewLeads = me?.all_permissions?.includes("view_leads") || me?.is_superuser;
  const canImport = me?.all_permissions?.includes("import_leads") || me?.is_superuser;
  const canExport = me?.all_permissions?.includes("export_leads") || me?.is_superuser;
  const canBulkAssign = me?.all_permissions?.includes("bulk_assign_leads") || me?.all_permissions?.includes("manage_leads") || me?.is_superuser;
  const canBulkDelete = me?.all_permissions?.includes("bulk_delete_leads") || me?.all_permissions?.includes("manage_leads") || me?.is_superuser;
  const canBulk = canBulkAssign || canBulkDelete;

  const canLog = (lead) => {
    if (!lead || !me) return false;
    if (me.is_superuser) return true;
    if (!canViewLeads) return false;
    return lead.assigned_to === me.id || lead.created_by === me.id;
  };

  const [leads, setLeads] = useState([]);
  const dynamicSourceOptions = (() => {
    const uniqueSourcesList = Array.from(new Set(leads.map(l => l.source).filter(Boolean)));
    return uniqueSourcesList.map(name => {
      const defaultOpt = SOURCE_OPTIONS.find(o => o.name === name);
      if (defaultOpt) return defaultOpt;
      return { name, icon: <IconStar />, color: "#6366f1" };
    });
  })();

  const formSourceOptions = (() => {
    const merged = [...SOURCE_OPTIONS];
    dynamicSourceOptions.forEach(opt => {
      if (!merged.find(m => m.name === opt.name)) {
        merged.push(opt);
      }
    });
    return merged;
  })();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalLeads, setTotalLeads] = useState(0);
  const [statusCounts, setStatusCounts] = useState({});
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [modal, setModal] = useState(null);
  const [activeLead, setActiveLead] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [followupForm, setFollowupForm] = useState({ type: 'Call', status: 'Completed', scheduled_at: localISO(), notes: '', setNextFollowup: false, nextFollowupDate: '', sub_status: '', custom_sub_status: '' });
  const [timelineTab, setTimelineTab] = useState("History");
  const [editingFollowupId, setEditingFollowupId] = useState(null);
  const [editNote, setEditNote] = useState("");
  const [errors, setErrors] = useState({});
  const [toastMsg, setToastMsg] = useState("");
  const [previewData, setPreviewData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [exportRemainingSeconds, setExportRemainingSeconds] = useState(0);
  const [isImporting, setIsImporting] = useState(false);
  const [importProgress, setImportProgress] = useState({ current: 0, total: 0 });
  const [showSources, setShowSources] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [activeSourceFilter, setActiveSourceFilter] = useState("All");
  const [assignedToFilter, setAssignedToFilter] = useState([]);
  const [leadTypeFilter, setLeadTypeFilter] = useState([]);
  const [courseFilter, setCourseFilter] = useState([]);
  const [universityFilter, setUniversityFilter] = useState([]);
  const [assignmentCountFilter, setAssignmentCountFilter] = useState("All");
  const [memberSearch, setMemberSearch] = useState("");
  const [deptFilter, setDeptFilter] = useState("All");
  const [showFormatModal, setShowFormatModal] = useState(false);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [isBulkProcessing, setIsBulkProcessing] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadTypes, setLeadTypes] = useState([]);
  const [importLeadType, setImportLeadType] = useState(null);
  const [importCustomLeadType, setImportCustomLeadType] = useState("");
  const [duplicateAction, setDuplicateAction] = useState('skip');
  const [importAssignedTo, setImportAssignedTo] = useState("");
  const [assignedDateStart, setAssignedDateStart] = useState("");
  const [assignedDateEnd, setAssignedDateEnd] = useState("");
  const [highlightedLeadId, setHighlightedLeadId] = useState(null);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [availableUniversities, setAvailableUniversities] = useState([]);
  const [firstAssigneeFilter, setFirstAssigneeFilter] = useState([]);
  const [maxAssignments, setMaxAssignments] = useState(0);
  const fileRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const hasActiveFilters = 
    search !== "" || 
    activeFilter !== "All" || 
    activeSourceFilter !== "All" || 
    assignedToFilter.length > 0 || 
    leadTypeFilter.length > 0 || 
    courseFilter.length > 0 || 
    universityFilter.length > 0 || 
    assignedDateStart !== "" || 
    assignedDateEnd !== "" ||
    assignmentCountFilter !== "All" ||
    firstAssigneeFilter.length > 0;

  const clearAllFilters = () => {
    setSearch("");
    setActiveFilter("All");
    setActiveSourceFilter("All");
    setAssignedToFilter([]);
    setLeadTypeFilter([]);
    setCourseFilter([]);
    setUniversityFilter([]);
    setAssignedDateStart("");
    setAssignedDateEnd("");
    setAssignmentCountFilter("All");
    setFirstAssigneeFilter([]);
    toast.success("All filters cleared");
  };

  const fetchFilterMetadata = async () => {
    try {
      const res = await api.get('crm/leads/filter_metadata/');
      setAvailableCourses(res.data.courses || []);
      setAvailableUniversities(res.data.companies || []);
      setMaxAssignments(res.data.max_assignments || 0);
    } catch (err) {
      console.error("Failed to fetch filter metadata", err);
    }
  };

  // Scroll highlighted lead into view
  useEffect(() => {
    if (highlightedLeadId && leads.length > 0) {
      const element = document.getElementById(`lead-row-${highlightedLeadId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [highlightedLeadId, leads]);

  const fetchTeam = async () => {
    try {
      const res = await api.get('accounts/users/');
      const data = res.data.results || res.data;
      setTeamMembers(data.filter(u => u.is_active !== false).map(u => ({
        ...u,
        name: `${u.first_name} ${u.last_name}`.trim() || u.username,
        load: u.assigned_leads_count || 0,
        performance: u.performance || 0
      })));
    } catch (err) { console.error("Failed to fetch team", err); }
  };

  const fetchLeadTypes = async () => {
    try {
      const res = await api.get('crm/lead-types/');
      setLeadTypes(res.data.results || res.data);
    } catch (err) { console.error("Failed to fetch lead types", err); }
  };

  useEffect(() => {
    fetchTeam();
    fetchLeadTypes();
    fetchFilterMetadata();
  }, []);

  const fetchLeads = async (page = 1, highlightId = null) => {
    try {
      const isSubStatusFilter = ["Course Not Available", "Will Think On It"].includes(activeFilter);
      const isMissedFilter = activeFilter === "Missed";
      
      const params = new URLSearchParams({
        page,
        search,
        status: (isSubStatusFilter || isMissedFilter) ? "All" : activeFilter,
        sub_status: isSubStatusFilter ? activeFilter.toLowerCase() : "",
        overdue: isMissedFilter ? "true" : "",
        source: activeSourceFilter,
        assigned_at_start: assignedDateStart,
        assigned_at_end: assignedDateEnd,
        assigned_to: assignedToFilter.length ? assignedToFilter.join(',') : "",
        lead_type: leadTypeFilter.length ? leadTypeFilter.join(',') : "",
        course: courseFilter.length ? courseFilter.join(',') : "",
        company: universityFilter.length ? universityFilter.join(',') : "",
        page_size: pageSize,
        highlight: highlightId || "",
        assignment_count: assignmentCountFilter !== "All" ? assignmentCountFilter : "",
        first_assignee: firstAssigneeFilter.length ? firstAssigneeFilter.join(',') : ""
      });
      const response = await api.get(`crm/leads/?${params.toString()}`);
      const data = response.data.results || [];
      setTotalLeads(response.data.count || data.length);
      const formatted = data.map(l => ({
        id: l.id,
        name: `${l.first_name} ${l.last_name}`.trim(),
        email: l.email,
        phone: l.phone,
        company: l.company,
        status: l.status,
        sub_status: l.sub_status || "",
        source: l.source || "Other",
        course: l.course,
        state: l.state,
        district: l.district,
        date: new Date(l.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }),
        avatar: initials(`${l.first_name} ${l.last_name}`),
        notes: l.notes,
        assigned_to: l.assigned_to,
        assigned_to_name: l.assigned_to_name,
        assigned_at: l.assigned_at,
        next_followup_date: l.next_followup_date,
        last_contacted_date: l.last_contacted_date,
        assignment_count: l.assignment_count,
        lead_type: l.lead_type,
        lead_type_name: l.lead_type_name,
        followups: (l.followups || []).sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at)),
        alternate_contacts: l.alternate_contacts || []
      }));
      setLeads(formatted);
      setCurrentPage(page);
      setStatusCounts(response.data.status_counts || {});
      return formatted;
    } catch (err) {
      console.error('Failed to fetch leads', err);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchLeads(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search, activeFilter, activeSourceFilter, pageSize, assignedDateStart, assignedDateEnd, assignedToFilter, leadTypeFilter, courseFilter, universityFilter, assignmentCountFilter, firstAssigneeFilter]);

  const formatLead = (l) => ({
    id: l.id,
    name: `${l.first_name} ${l.last_name}`.trim(),
    email: l.email,
    phone: l.phone,
    company: l.company,
    status: l.status,
    sub_status: l.sub_status || "",
    source: l.source || "Other",
    course: l.course,
    state: l.state,
    district: l.district,
    date: new Date(l.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }),
    avatar: initials(`${l.first_name} ${l.last_name}`),
    notes: l.notes,
    assigned_to: l.assigned_to,
    assigned_to_name: l.assigned_to_name,
    assigned_at: l.assigned_at,
    next_followup_date: l.next_followup_date,
    last_contacted_date: l.last_contacted_date,
    assignment_count: l.assignment_count,
    lead_type: l.lead_type,
    lead_type_name: l.lead_type_name,
    followups: (l.followups || []).sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at)),
    alternate_contacts: l.alternate_contacts || []
  });

  // Listen for global interaction saves (e.g. from the telephony modal)
  useEffect(() => {
    const handleGlobalSave = async (e) => {
      if (e.detail?.updatedLead) {
        const fresh = formatLead(e.detail.updatedLead);
        setLeads(prev => prev.map(l => l.id === fresh.id ? fresh : l));
        if (activeLead && fresh.id === activeLead.id) {
          setActiveLead(fresh);
        }
      } else {
        // Fallback for cases where data isn't passed
        const updated = await fetchLeads(currentPage);
        if (activeLead && e.detail?.lead_id === activeLead.id) {
          const fresh = updated?.find(l => l.id === activeLead.id);
          if (fresh) setActiveLead(fresh);
        }
      }
    };
    window.addEventListener('crm:interaction_saved', handleGlobalSave);
    return () => window.removeEventListener('crm:interaction_saved', handleGlobalSave);
  }, [currentPage, activeLead, search, activeFilter, activeSourceFilter, pageSize]);


  const counts = ALL_STATUSES.reduce((acc, s) => {
    acc[s] = statusCounts[s] || 0; return acc;
  }, {});

  const showToast = (msg) => { setToastMsg(msg); setTimeout(() => setToastMsg(""), 3200); };

  const handleErrorScrollAndFocus = (errObj) => {
    const fieldOrder = ['name', 'phone', 'email', 'company', 'course', 'state', 'district'];
    const activeErrKey = fieldOrder.find(k => errObj[k]);
    if (activeErrKey) {
      setTimeout(() => {
        const target = document.querySelector(`[data-field="${activeErrKey}"]`);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.focus();
        }
      }, 150);
    } else if (errObj.alternate_contacts) {
      const firstIdx = errObj.alternate_contacts.findIndex(x => x && (x.phone || x.email || x.guardian_name));
      if (firstIdx >= 0) {
        const errItem = errObj.alternate_contacts[firstIdx];
        const subField = errItem.phone ? 'phone' : (errItem.email ? 'email' : 'guardian');
        setTimeout(() => {
          const target = document.querySelector(`[data-field="alt_${subField}_${firstIdx}"]`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            target.focus();
          }
        }, 150);
      }
    }
  };

  const validate = (f) => {
    const e = {};
    if (!f.name.trim()) e.name = "Name is required";
    if (!f.phone.trim()) e.phone = "Phone number is required";
    if (f.email.trim() && !/\S+@\S+\.\S+/.test(f.email)) e.email = "Invalid email format";
    
    if (f.alternate_contacts && f.alternate_contacts.length) {
      const altErrs = [];
      let hasAltErr = false;
      f.alternate_contacts.forEach((alt, idx) => {
        const itemErr = {};
        if (alt.email && alt.email.trim() && !/\S+@\S+\.\S+/.test(alt.email)) {
          itemErr.email = "Invalid email format";
          hasAltErr = true;
        }
        altErrs[idx] = itemErr;
      });
      if (hasAltErr) {
        e.alternate_contacts = altErrs;
      }
    }
    return e;
  };

  const openAdd = () => { 
    fetchLeadTypes();
    setForm(EMPTY_FORM); setErrors({}); setModal("add"); 
  };
  const openView = (lead) => {
    setActiveLead(lead);
    setTimelineTab("History");
    setModal("view");
    setFollowupForm({ type: 'Call', status: 'Completed', scheduled_at: localISO(), notes: '', setNextFollowup: false, nextFollowupDate: '', sub_status: lead.sub_status || '', custom_sub_status: '' });
  };
  const openEdit = (lead) => {
    fetchLeadTypes();
    setActiveLead(lead);
    setForm({
      name: lead.name,
      email: lead.email,
      phone: lead.phone,
      company: lead.company,
      status: lead.status,
      value: lead.value,
      notes: lead.notes || "",
      source: lead.source || "Website",
      assigned_to: lead.assigned_to,
      lead_type: lead.lead_type,
      state: lead.state || "",
      district: lead.district || "",
      course: lead.course || "",
      sub_status: lead.sub_status || "",
      alternate_contacts: lead.alternate_contacts ? [...lead.alternate_contacts] : []
    });
    setErrors({});
    setModal("edit");
  };
  const openCombined = (lead) => {
    fetchLeadTypes();
    setActiveLead(lead);
    setForm({
      name: lead.name,
      email: lead.email,
      phone: lead.phone,
      company: lead.company,
      status: lead.status,
      value: lead.value,
      notes: lead.notes || "",
      source: lead.source || "Website",
      assigned_to: lead.assigned_to,
      lead_type: lead.lead_type,
      state: lead.state || "",
      district: lead.district || "",
      course: lead.course || "",
      sub_status: lead.sub_status || "",
      alternate_contacts: lead.alternate_contacts ? [...lead.alternate_contacts] : []
    });
    setFollowupForm({ type: 'Call', status: 'Completed', scheduled_at: localISO(), notes: '', setNextFollowup: false, nextFollowupDate: '', sub_status: lead.sub_status || '', custom_sub_status: '' });
    setTimelineTab("History");
    setErrors({});
    setModal("combined");
  };

  const openDelete = (lead) => { setActiveLead(lead); setModal("delete"); };
  const openAssign = (lead) => { setActiveLead(lead); setMemberSearch(""); setDeptFilter("All"); setModal("assign"); };
  const openBulkAssign = () => { setMemberSearch(""); setDeptFilter("All"); setModal("bulk_assign"); };
  const openBulkDelete = () => { setModal("bulk_delete"); };
  const closeModal = () => { setModal(null); setActiveLead(null); setErrors({}); };

  const toggleSelectAll = () => {
    if (selectedLeadIds.length === leads.length) {
      setSelectedLeadIds([]);
    } else {
      setSelectedLeadIds(leads.map(l => l.id));
    }
  };

  const toggleSelectLead = (id) => {
    setSelectedLeadIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const LEAD_ENDPOINT = "crm/leads/";

  const handleAdd = async () => {
    const e = validate(form); if (Object.keys(e).length) { setErrors(e); handleErrorScrollAndFocus(e); return; }
    const [first_name, ...last] = form.name.split(" ");
    const payload = {
      first_name,
      last_name: last.join(" "),
      email: form.email,
      phone: form.phone,
      company: form.company,
      status: form.status,
      sub_status: form.sub_status === "Other" ? form.custom_sub_status : form.sub_status,
      course: form.course,
      state: form.state,
      district: form.district,
      notes: form.notes,
      source: form.source,
      assigned_to: form.assigned_to,
      lead_type: form.lead_type,
      alternate_contacts: form.alternate_contacts || []
    };
    try {
      const res = await api.post(LEAD_ENDPOINT, payload);
      const newLead = {
        ...res.data,
        name: `${res.data.first_name} ${res.data.last_name}`.trim(),
        avatar: initials(`${res.data.first_name} ${res.data.last_name}`),
        date: new Date(res.data.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
      };
      fetchLeads(currentPage);
      showToast("Lead added successfully");
      fetchFilterMetadata();
      closeModal();
    } catch (err) {
      if (err.response?.data) {
        const backendErrors = err.response.data;
        const mappedErrors = { ...backendErrors };
        if (backendErrors.first_name) {
          mappedErrors.name = backendErrors.first_name[0] || backendErrors.first_name;
        } else if (backendErrors.last_name) {
          mappedErrors.name = backendErrors.last_name[0] || backendErrors.last_name;
        }
        setErrors(mappedErrors);
        handleErrorScrollAndFocus(mappedErrors);
      }
      const errorMsg = err.response?.data?.phone?.[0] || err.response?.data?.email?.[0] || err.response?.data?.detail || "Add failed";
      showToast("Add failed. Please correct the highlighted errors.");
    }
  };

  const handleEdit = async () => {
    const e = validate(form); if (Object.keys(e).length) { setErrors(e); handleErrorScrollAndFocus(e); return; }
    const [first_name, ...last] = form.name.split(" ");
    const payload = {
      first_name,
      last_name: last.join(" "),
      email: form.email,
      phone: form.phone,
      company: form.company,
      status: form.status,
      sub_status: form.sub_status === "Other" ? form.custom_sub_status : form.sub_status,
      course: form.course,
      state: form.state,
      district: form.district,
      notes: form.notes,
      source: form.source,
      assigned_to: form.assigned_to,
      lead_type: form.lead_type,
      alternate_contacts: form.alternate_contacts || []
    };
    try {
      const res = await api.put(`${LEAD_ENDPOINT}${activeLead.id}/`, payload);
      fetchLeads(currentPage);
      showToast("Lead updated successfully");
      fetchFilterMetadata();
      closeModal();
    } catch (err) {
      if (err.response?.data) {
        const backendErrors = err.response.data;
        const mappedErrors = { ...backendErrors };
        if (backendErrors.first_name) {
          mappedErrors.name = backendErrors.first_name[0] || backendErrors.first_name;
        } else if (backendErrors.last_name) {
          mappedErrors.name = backendErrors.last_name[0] || backendErrors.last_name;
        }
        setErrors(mappedErrors);
        handleErrorScrollAndFocus(mappedErrors);
      }
      const errorMsg = err.response?.data?.phone?.[0] || err.response?.data?.email?.[0] || err.response?.data?.detail || "Update failed";
      showToast("Update failed. Please correct the highlighted errors.");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlightId = params.get('highlight');
    if (highlightId) {
      const id = parseInt(highlightId);
      setHighlightedLeadId(id);
      
      // If not on current page, re-fetch with highlight priority
      const leadOnPage = leads.find(l => l.id === id);
      if (!leadOnPage && leads.length > 0) {
        fetchLeads(1, id);
      }
      
      // Remove ?highlight=... from URL without reloading the page
      params.delete('highlight');
      const newSearch = params.toString();
      navigate({
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : ''
      }, { replace: true });

      // Clear highlight visual after 5 seconds
      setTimeout(() => setHighlightedLeadId(null), 5000);
    }
  }, [location, navigate, leads]);

  const handleAssign = async (userId) => {
    try {
      const res = await api.patch(`${LEAD_ENDPOINT}${activeLead.id}/`, { assigned_to: userId });
      const updatedLead = formatLead(res.data);
      setLeads(prev => prev.map(l => l.id === activeLead.id ? updatedLead : l));
      setActiveLead(updatedLead);
      showToast(userId ? "Lead assigned" : "Lead unassigned");
      if (modal === "assign" && userId) closeModal();
    } catch (err) { showToast("Assignment failed"); }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`${LEAD_ENDPOINT}${activeLead.id}/`);
      fetchLeads(currentPage);
      showToast("Lead deleted");
      fetchFilterMetadata();
      closeModal();
    } catch (err) { showToast("Delete failed"); }
  };

  const handleBulkAssign = async (userId) => {
    if (isBulkProcessing) return;
    setIsBulkProcessing(true);
    try {
      await api.post(`${LEAD_ENDPOINT}bulk_assign/`, {
        lead_ids: selectedLeadIds,
        user_id: userId
      });
      showToast(`${selectedLeadIds.length} leads assigned successfully`);
      setSelectedLeadIds([]);
      fetchLeads(currentPage);
      closeModal();
    } catch (err) {
      showToast("Bulk assignment failed");
    } finally {
      setIsBulkProcessing(false);
    }
  };

  const handleBulkDelete = async () => {
    if (isBulkProcessing) return;
    setIsBulkProcessing(true);
    try {
      await api.post(`${LEAD_ENDPOINT}bulk_delete/`, {
        lead_ids: selectedLeadIds
      });
      showToast(`${selectedLeadIds.length} leads deleted successfully`);
      setSelectedLeadIds([]);
      fetchLeads(currentPage);
      fetchFilterMetadata();
      closeModal();
    } catch (err) {
      showToast("Bulk delete failed");
    } finally {
      setIsBulkProcessing(false);
    }
  };

  const [isLogging, setIsLogging] = useState(false);
  const handleLogFollowup = async () => {
    if (isLogging) return;
    if (!followupForm.scheduled_at) {
      showToast("Date is required");
      return;
    }
    setIsLogging(true);
    try {
      const payload = {
        sub_status: followupForm.sub_status,
        custom_sub_status: followupForm.custom_sub_status,
        note: followupForm.notes,
        status: followupForm.status, // Keeping for backward compatibility
        interaction_status: followupForm.status,
        lead_status: activeLead.status, 
        scheduled_at: followupForm.scheduled_at,
        next_followup_date: followupForm.setNextFollowup ? followupForm.nextFollowupDate : null,
        interaction_type: followupForm.type
      };

      await api.post(`crm/leads/${activeLead.id}/log_interaction/`, payload);

      const updatedLeads = await fetchLeads(currentPage);
      const current = updatedLeads.find(l => l.id === activeLead.id);
      setActiveLead(current);
      setFollowupForm({ type: 'Call', status: 'Completed', scheduled_at: localISO(), notes: '', setNextFollowup: false, nextFollowupDate: '', sub_status: current.sub_status || '' });
      showToast("Interaction logged");
    } catch (err) {
      showToast("Failed to log interaction");
    } finally {
      setIsLogging(false);
    }
  };

  const handleSaveEverything = async () => {
    if (isLogging) return;
    const e = validate(form);
    if (Object.keys(e).length) {
      setErrors(e);
      handleErrorScrollAndFocus(e);
      showToast("Please correct the highlighted errors before saving.");
      return;
    }

    const [first_name, ...last] = form.name.split(" ");
    const payload = {
      first_name,
      last_name: last.join(" "),
      email: form.email,
      phone: form.phone,
      company: form.company,
      status: form.status,
      sub_status: form.sub_status === "Other" ? form.custom_sub_status : form.sub_status,
      course: form.course,
      state: form.state,
      district: form.district,
      notes: form.notes,
      source: form.source,
      assigned_to: form.assigned_to,
      lead_type: form.lead_type,
      alternate_contacts: form.alternate_contacts || []
    };

    setIsLogging(true);
    try {
      await api.put(`${LEAD_ENDPOINT}${activeLead.id}/`, payload);

      const hasInteractionData = followupForm.notes.trim() !== "" || followupForm.setNextFollowup;
      if (hasInteractionData && canLog(activeLead)) {
        if (!followupForm.scheduled_at) {
          showToast("Date is required to save interaction");
          setIsLogging(false);
          return;
        }
        const interactionPayload = {
          sub_status: followupForm.sub_status,
          custom_sub_status: followupForm.custom_sub_status,
          note: followupForm.notes,
          status: followupForm.status,
          interaction_status: followupForm.status,
          lead_status: form.status,
          scheduled_at: followupForm.scheduled_at,
          next_followup_date: followupForm.setNextFollowup ? followupForm.nextFollowupDate : null,
          interaction_type: followupForm.type
        };
        await api.post(`crm/leads/${activeLead.id}/log_interaction/`, interactionPayload);
        setFollowupForm({ type: 'Call', status: 'Completed', scheduled_at: localISO(), notes: '', setNextFollowup: false, nextFollowupDate: '', sub_status: '' });
      }

      await fetchLeads(currentPage);
      showToast("Lead & Interactions saved successfully!");
      fetchFilterMetadata();
      closeModal();
    } catch (err) {
      if (err.response?.data) {
        const backendErrors = err.response.data;
        const mappedErrors = { ...backendErrors };
        if (backendErrors.first_name) {
          mappedErrors.name = backendErrors.first_name[0] || backendErrors.first_name;
        } else if (backendErrors.last_name) {
          mappedErrors.name = backendErrors.last_name[0] || backendErrors.last_name;
        }
        setErrors(mappedErrors);
        handleErrorScrollAndFocus(mappedErrors);
      }
      showToast("Save failed. Please correct the highlighted errors.");
    } finally {
      setIsLogging(false);
    }
  };

  const handleUpdateFollowup = async (fId, payload) => {
    try {
      await api.patch(`crm/lead-followups/${fId}/`, payload);
      const updatedLeads = await fetchLeads(currentPage);
      const current = updatedLeads.find(l => l.id === activeLead.id);
      setActiveLead(current);
      setEditingFollowupId(null);
      showToast("Interaction updated");
    } catch (err) {
      const msg = err.response?.data ? JSON.stringify(err.response.data) : err.message;
      showToast(`Update failed (ID: ${fId}): ${msg}`);
    }
  };

  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    
    // Highly optimized backend serialization takes ~0.08ms per record (0.08s per 1000), plus a base latency of 0.4s.
    const estTime = Math.max(1, Math.ceil(totalLeads * 0.00008 + 0.4));
    setExportRemainingSeconds(estTime);

    const intervalId = setInterval(() => {
      setExportRemainingSeconds(prev => {
        if (prev <= 1) return 1; // Clamp at 1s remaining until actual request finishes
        return prev - 1;
      });
    }, 1000);

    try {
      showToast(`Preparing export of ${totalLeads} leads...`);
      const isSubStatusFilter = ["Course Not Available", "Will Think On It"].includes(activeFilter);
      const isMissedFilter = activeFilter === "Missed";
      
      const params = new URLSearchParams({
        search,
        status: (isSubStatusFilter || isMissedFilter) ? "All" : activeFilter,
        sub_status: isSubStatusFilter ? activeFilter.toLowerCase() : "",
        overdue: isMissedFilter ? "true" : "",
        source: activeSourceFilter,
        assigned_at_start: assignedDateStart,
        assigned_at_end: assignedDateEnd,
        assigned_to: assignedToFilter.length ? assignedToFilter.join(',') : "",
        lead_type: leadTypeFilter.length ? leadTypeFilter.join(',') : "",
        course: courseFilter.length ? courseFilter.join(',') : "",
        company: universityFilter.length ? universityFilter.join(',') : ""
      });

      const res = await api.get(`crm/leads/export_all/?${params.toString()}`);
      const allLeads = res.data || [];
      
      const headers = [
        "Name", 
        "Email", 
        "Phone", 
        "University", 
        "Status", 
        "Sub Status", 
        "Assigned To", 
        "General Note", 
        "Latest Note", 
        "Date"
      ];
      
      const rows = [
        headers, 
        ...allLeads.map(l => [
          `${l.first_name || ""} ${l.last_name || ""}`.trim() || "—",
          l.email || "—",
          l.phone || "—",
          l.company || "—",
          l.status || "—",
          l.sub_status || "—",
          l.assigned_to_name || "Unassigned",
          (l.notes || "").replace(/\r?\n|\r/g, " "), // strip newlines for csv safety
          (l.latest_note || "").replace(/\r?\n|\r/g, " "),
          new Date(l.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
        ])
      ];

      // Convert rows to CSV format, handling quotes and escaping properly
      const csvContent = rows
        .map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", `leads_export_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showToast("Export completed successfully!");
    } catch (err) {
      console.error("Export failed", err);
      showToast("Export failed. Please try again.");
    } finally {
      clearInterval(intervalId);
      setIsExporting(false);
      setExportRemainingSeconds(0);
    }
  };

  const handleImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');

    reader.onload = async (ev) => {
      try {
        let imported = [];
        if (isExcel) {
          const data = new Uint8Array(ev.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          if (jsonData.length < 2) throw new Error("Empty Excel file");

          const hdr = jsonData[0].map(h => String(h || "").trim().toLowerCase());
          const gi = (k) => hdr.indexOf(k);

          imported = jsonData.slice(1).map((row, i) => {
            if (!row || row.length === 0 || row.every(cell => !cell)) return null;
            
            const fullName = gi("name") >= 0 ? String(row[gi("name")] || "") : "";
            const fName = gi("first_name") >= 0 ? String(row[gi("first_name")] || "") : (fullName.split(" ")[0] || `Lead`);
            const lName = gi("last_name") >= 0 ? String(row[gi("last_name")] || "") : (fullName.split(" ").slice(1).join(" ") || "");
            const rawStatus = gi("status") >= 0 ? String(row[gi("status")] || "") : "New";
            const status = ["New", "Contacted", "Interested", "Form Filled", "Admission Done", "Pipeline", "Lost"].includes(rawStatus) ? rawStatus : "New";

            const phone = gi("phone") >= 0 ? String(row[gi("phone")] || "").replace(/\D/g, '') : "";

            const isInvalid = !fName || !phone || phone.length !== 10;

            const altPhone = gi("alternate_phone") >= 0 ? String(row[gi("alternate_phone")] || "").replace(/\D/g, '') : 
                             (gi("alternate phone") >= 0 ? String(row[gi("alternate phone")] || "").replace(/\D/g, '') : "");
            const altEmail = gi("alternate_email") >= 0 ? String(row[gi("alternate_email")] || "") : 
                             (gi("alternate email") >= 0 ? String(row[gi("alternate email")] || "") : "");
            const altGuardian = gi("alternate_guardian") >= 0 ? String(row[gi("alternate_guardian")] || "") : 
                                (gi("alternate guardian") >= 0 ? String(row[gi("alternate guardian")] || "") : 
                                (gi("guardian_name") >= 0 ? String(row[gi("guardian_name")] || "") : 
                                (gi("guardian name") >= 0 ? String(row[gi("guardian name")] || "") : "")));

            const alternate_contacts = [];
            if (altPhone || altEmail || altGuardian) {
              alternate_contacts.push({ phone: altPhone, email: altEmail, guardian_name: altGuardian });
            }

            return {
              id: Date.now() + i,
              first_name: fName,
              last_name: lName,
              email: gi("email") >= 0 ? String(row[gi("email")] || "") : "",
              phone,
              company: gi("university") >= 0 ? String(row[gi("university")] || "") : 
                       (gi("company") >= 0 ? String(row[gi("company")] || "") : ""),
              status,
              sub_status: gi("sub_status") >= 0 ? String(row[gi("sub_status")] || "") : "",
              course: gi("course") >= 0 ? String(row[gi("course")] || "") : "",
              state: gi("state") >= 0 ? String(row[gi("state")] || "") : "",
              district: gi("district") >= 0 ? String(row[gi("district")] || "") : "",
              source: gi("source") >= 0 ? String(row[gi("source")] || "") : "Website",
              notes: gi("notes") >= 0 ? String(row[gi("notes")] || "") : "",
              isInvalid,
              alternate_contacts
            };
          }).filter(Boolean);
        } else {
          const lines = ev.target.result.split("\n").filter(Boolean);
          const hdr = lines[0].split(",").map(h => h.replace(/"/g, "").trim().toLowerCase());
          const gi = (k) => hdr.indexOf(k);

          imported = lines.slice(1).map((line, i) => {
            const c = line.split(",").map(x => x.replace(/"/g, "").trim());
            if (c.every(cell => !cell)) return null;

            const fullName = gi("name") >= 0 ? c[gi("name")] : "";
            const fName = gi("first_name") >= 0 ? c[gi("first_name")] : (fullName.split(" ")[0] || `Lead`);
            const lName = gi("last_name") >= 0 ? c[gi("last_name")] : (fullName.split(" ").slice(1).join(" ") || "");
            const rawStatus = gi("status") >= 0 ? c[gi("status")] : "New";
            const status = ["New", "Contacted", "Interested", "Form Filled", "Admission Done", "Pipeline", "Lost"].includes(rawStatus) ? rawStatus : "New";

            const phone = (c[gi("phone")] || "").replace(/\D/g, '');

            const isInvalid = !fName || !phone || phone.length !== 10;

            const altPhone = gi("alternate_phone") >= 0 ? (c[gi("alternate_phone")] || "").replace(/\D/g, '') : 
                             (gi("alternate phone") >= 0 ? (c[gi("alternate phone")] || "").replace(/\D/g, '') : "");
            const altEmail = gi("alternate_email") >= 0 ? (c[gi("alternate_email")] || "") : 
                             (gi("alternate email") >= 0 ? (c[gi("alternate email")] || "") : "");
            const altGuardian = gi("alternate_guardian") >= 0 ? (c[gi("alternate_guardian")] || "") : 
                                (gi("alternate guardian") >= 0 ? (c[gi("alternate guardian")] || "") : 
                                (gi("guardian_name") >= 0 ? (c[gi("guardian_name")] || "") : 
                                (gi("guardian name") >= 0 ? (c[gi("guardian name")] || "") : "")));

            const alternate_contacts = [];
            if (altPhone || altEmail || altGuardian) {
              alternate_contacts.push({ phone: altPhone, email: altEmail, guardian_name: altGuardian });
            }

            return {
              id: Date.now() + i,
              first_name: fName,
              last_name: lName,
              email: c[gi("email")] || "",
              phone,
              company: gi("university") >= 0 ? (c[gi("university")] || "") : 
                       (gi("company") >= 0 ? (c[gi("company")] || "") : ""),
              status,
              sub_status: gi("sub_status") >= 0 ? c[gi("sub_status")] : "",
              course: gi("course") >= 0 ? c[gi("course")] : "",
              state: gi("state") >= 0 ? c[gi("state")] : "",
              district: gi("district") >= 0 ? c[gi("district")] : "",
              source: gi("source") >= 0 ? c[gi("source")] : "Website",
              notes: c[gi("notes")] || "",
              isInvalid,
              alternate_contacts
            };
          }).filter(Boolean);
        }

        // Backend Duplicate Check
        const allEmails = imported.map(l => l.email).filter(Boolean);
        const allPhones = imported.map(l => l.phone).filter(Boolean);

        const dupRes = await api.post('crm/leads/check_duplicates/', {
          emails: allEmails,
          phones: allPhones
        });

        const { existing_emails, existing_phones } = dupRes.data;
        const existingEmailsSet = new Set(existing_emails);
        const existingPhonesSet = new Set(existing_phones);

        const preview = imported.map(l => ({
          ...l,
          name: `${l.first_name} ${l.last_name}`.trim(),
          isDuplicate: (l.email && existingEmailsSet.has(l.email)) || (l.phone && existingPhonesSet.has(l.phone))
        }));

        setPreviewData(preview);
        setShowPreview(true);
        setShowFormatModal(false);
      } catch (err) {
        console.error(err);
        showToast("Failed to parse or verify file");
      }
    };
    if (isExcel) reader.readAsArrayBuffer(file);
    else reader.readAsText(file);
    e.target.value = "";
  };

  const [showBufferModal, setShowBufferModal] = useState(false);
  const [bufferLeads, setBufferLeads] = useState([]);
  const [bufferLoading, setBufferLoading] = useState(false);
  const [editBufferLead, setEditBufferLead] = useState(null);

  const fetchBufferLeads = async () => {
    try {
      setBufferLoading(true);
      const res = await api.get('crm/webhooks/buffer/?status=pending');
      setBufferLeads(res.data || []);
    } catch (err) {
      console.error("Error fetching webhook buffer leads", err);
    } finally {
      setBufferLoading(false);
    }
  };

  const handleTransfer = async (id, mode) => {
    try {
      const res = await api.post(`crm/webhooks/buffer/${id}/transfer/`, { mode });
      toast.success(res.data.message || "Lead transferred successfully");
      fetchBufferLeads();
      fetchLeads(currentPage);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to transfer lead");
    }
  };

  const handleIgnore = async (id) => {
    if (!window.confirm("Are you sure you want to ignore and discard this buffered lead?")) return;
    try {
      await api.post(`crm/webhooks/buffer/${id}/ignore/`);
      toast.success("Lead ignored successfully");
      fetchBufferLeads();
    } catch (err) {
      toast.error("Failed to ignore lead");
    }
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    if (!editBufferLead) return;
    try {
      await api.patch(`crm/webhooks/buffer/${editBufferLead.id}/`, editBufferLead);
      toast.success("Buffered lead details updated!");
      setEditBufferLead(null);
      fetchBufferLeads();
    } catch (err) {
      toast.error("Failed to update lead details");
    }
  };

  useEffect(() => {
    fetchBufferLeads();
  }, []);

  const uniqueCourses = availableCourses;
  const uniqueUniversities = availableUniversities;

  return (
    <div className="ld-root">
      <div className="ld-header">
        <div className="ld-title-block">
          <span className="ld-eyebrow">CRM</span>
          <h1 className="ld-title">Leads</h1>
          <p className="ld-subtitle">{leads.length} total leads · Last updated today</p>
        </div>
        <div className="ld-header-btns">
          {canImport && (
            <button className="ld-io-btn" onClick={() => { fetchLeadTypes(); setShowFormatModal(true); }}>
              <IconUpload /> Import
            </button>
          )}
          {me && (
            me.is_superuser || 
            me.role === 'admin' || 
            me.role === 'manager' || 
            me.role === 'primary_org_admin' || 
            me.all_permissions?.includes("manage_leads") ||
            me.all_permissions?.includes("manage_ngo_leads") ||
            me.all_permissions?.includes("manage_education_enquiry") ||
            me.all_permissions?.includes("manage_corporate_leads")
          ) && (
            <button 
              className="ld-io-btn" 
              onClick={() => { fetchBufferLeads(); setShowBufferModal(true); }}
              style={{ position: 'relative' }}
            >
              <i className="fa-solid fa-list-check" style={{ marginRight: 6 }} /> Webhook Buffer
              {bufferLeads.length > 0 && (
                <span style={{
                  position: 'absolute', top: '-6px', right: '-6px',
                  background: '#ef4444', color: '#fff', fontSize: '10px',
                  padding: '2px 6px', borderRadius: '10px', fontWeight: 'bold'
                }}>
                  {bufferLeads.length}
                </span>
              )}
            </button>
          )}
          <input ref={fileRef} type="file" accept=".csv, .xlsx, .xls" style={{ display: "none" }} onChange={handleImport} />
          {canExport && (
            <button 
              className="ld-io-btn" 
              onClick={handleExport}
              disabled={isExporting}
              style={isExporting ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
            >
              <IconDownload /> {isExporting ? `Exporting (${exportRemainingSeconds}s...)` : "Export"}
            </button>
          )}
          {canAdd && (
            <button className="ld-add-btn" onClick={openAdd}>
              <IconPlus /> Add Lead
            </button>
          )}
        </div>
      </div>

      {toastMsg && <div className="ld-toast">{toastMsg}</div>}

      <div className="ld-summary">
        <div className="ld-status-dropdown-container">
          <button 
            className={`ld-status-dropdown-trigger${activeFilter !== "All" ? " has-filter" : ""}`}
            onClick={() => setIsStatusOpen(!isStatusOpen)}
          >
            <div className="ld-status-trigger-content">
              {activeFilter !== "All" && (
                <div className="ld-pill-dot" style={{ background: (STATUS_CFG[activeFilter] || STATUS_CFG.New).dot }} />
              )}
              <span className="ld-status-trigger-text">
                {activeFilter === "All" ? "Filter by Status" : activeFilter}
              </span>
              <span className="ld-pill-count">{counts[activeFilter]}</span>
            </div>
            <div className="ld-status-chevron">
              <IconChevron up={isStatusOpen} />
            </div>
          </button>

          {isStatusOpen && (
            <>
              <div className="ld-dropdown-overlay" onClick={() => setIsStatusOpen(false)} />
              <div className="ld-status-menu">
                <div className="ld-status-menu-header">Select Status</div>
                <div className="ld-status-menu-list">
                  {ALL_STATUSES.map(s => (
                    <button 
                      key={s} 
                      className={`ld-status-menu-item${activeFilter === s ? " active" : ""}`} 
                      onClick={() => { setActiveFilter(s); setIsStatusOpen(false); }}
                    >
                      <div className="ld-status-item-left">
                        {s !== "All" && <div className="ld-pill-dot" style={{ background: (STATUS_CFG[s] || STATUS_CFG.New).dot }} />}
                        <span className="ld-status-name">{s}</span>
                      </div>
                      <span className="ld-pill-count">{counts[s]}</span>
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>

        {/* Clear All Filters Button */}
        {hasActiveFilters && (
          <button className="ld-clear-filter-btn" onClick={clearAllFilters}>
            Clear All Filters ✕
          </button>
        )}
      </div>

      <div className="ld-toolbar">
        <div className="ld-search-wrap">
          <div className="ld-search-icon"><IconSearch /></div>
          <input className="ld-search" placeholder="Search leads or employees…" 
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className="ld-filter-group">
          {/* Employee Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${assignedToFilter.length > 0 ? " active" : ""}`} onClick={() => setModal(modal === "filter_emp" ? null : "filter_emp")}>
              <span className="ld-filter-btn-icon"><IconUser /></span>
              <span className="ld-filter-btn-text">
                {assignedToFilter.length === 0 ? "All Employees" : `${assignedToFilter.length} Selected`}
              </span>
              <IconChevron up={modal === "filter_emp"} />
            </button>
            {modal === "filter_emp" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    <button className={`ld-dropdown-item${assignedToFilter.length === 0 ? " active" : ""}`} onClick={() => { setAssignedToFilter([]); }}>
                      <input type="checkbox" checked={assignedToFilter.length === 0} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      All Employees
                    </button>
                    <button className={`ld-dropdown-item${assignedToFilter.includes("unassigned") ? " active" : ""}`} onClick={() => {
                      setAssignedToFilter(prev => prev.includes("unassigned") ? prev.filter(x => x !== "unassigned") : [...prev, "unassigned"]);
                    }}>
                      <input type="checkbox" checked={assignedToFilter.includes("unassigned")} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      Unassigned Leads
                    </button>
                    {teamMembers.map(m => (
                      <button key={m.id} className={`ld-dropdown-item${assignedToFilter.includes(String(m.id)) ? " active" : ""}`} onClick={() => {
                        const mid = String(m.id);
                        setAssignedToFilter(prev => prev.includes(mid) ? prev.filter(x => x !== mid) : [...prev, mid]);
                      }}>
                        <input type="checkbox" checked={assignedToFilter.includes(String(m.id))} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {m.name}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Course Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${courseFilter.length > 0 ? " active" : ""}`} onClick={() => setModal(modal === "filter_course" ? null : "filter_course")}>
              <span className="ld-filter-btn-icon"><IconGraduation /></span>
              <span className="ld-filter-btn-text">
                {courseFilter.length === 0 ? "All Courses" : `${courseFilter.length} Selected`}
              </span>
              <IconChevron up={modal === "filter_course"} />
            </button>
            {modal === "filter_course" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    <button className={`ld-dropdown-item${courseFilter.length === 0 ? " active" : ""}`} onClick={() => { setCourseFilter([]); }}>
                      <input type="checkbox" checked={courseFilter.length === 0} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      All Courses
                    </button>
                    {uniqueCourses.map(c => (
                      <button key={c} className={`ld-dropdown-item${courseFilter.includes(c) ? " active" : ""}`} onClick={() => {
                        setCourseFilter(prev => prev.includes(c) ? prev.filter(x => x !== c) : [...prev, c]);
                      }}>
                        <input type="checkbox" checked={courseFilter.includes(c)} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {c}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* School Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${universityFilter.length > 0 ? " active" : ""}`} onClick={() => setModal(modal === "filter_university" ? null : "filter_university")}>
              <span className="ld-filter-btn-icon"><IconBuilding /></span>
              <span className="ld-filter-btn-text">
                {universityFilter.length === 0 ? "All Universities" : `${universityFilter.length} Selected`}
              </span>
              <IconChevron up={modal === "filter_university"} />
            </button>
            {modal === "filter_university" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    <button className={`ld-dropdown-item${universityFilter.length === 0 ? " active" : ""}`} onClick={() => { setUniversityFilter([]); }}>
                      <input type="checkbox" checked={universityFilter.length === 0} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      All Universities
                    </button>
                    {uniqueUniversities.map(c => (
                      <button key={c} className={`ld-dropdown-item${universityFilter.includes(c) ? " active" : ""}`} onClick={() => {
                        setUniversityFilter(prev => prev.includes(c) ? prev.filter(x => x !== c) : [...prev, c]);
                      }}>
                        <input type="checkbox" checked={universityFilter.includes(c)} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {c}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Lead Type Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${leadTypeFilter.length > 0 ? " active" : ""}`} onClick={() => setModal(modal === "filter_type" ? null : "filter_type")}>
              <span className="ld-filter-btn-icon"><IconTag /></span>
              <span className="ld-filter-btn-text">
                {leadTypeFilter.length === 0 ? "All Lead Types" : `${leadTypeFilter.length} Selected`}
              </span>
              <IconChevron up={modal === "filter_type"} />
            </button>
            {modal === "filter_type" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    <button className={`ld-dropdown-item${leadTypeFilter.length === 0 ? " active" : ""}`} onClick={() => { setLeadTypeFilter([]); }}>
                      <input type="checkbox" checked={leadTypeFilter.length === 0} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      All Lead Types
                    </button>
                    {leadTypes.map(lt => (
                      <button key={lt.id} className={`ld-dropdown-item${leadTypeFilter.includes(String(lt.id)) ? " active" : ""}`} onClick={() => {
                        const ltid = String(lt.id);
                        setLeadTypeFilter(prev => prev.includes(ltid) ? prev.filter(x => x !== ltid) : [...prev, ltid]);
                      }}>
                        <input type="checkbox" checked={leadTypeFilter.includes(String(lt.id))} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {lt.name}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Assignment Count Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${assignmentCountFilter !== "All" ? " active" : ""}`} onClick={() => setModal(modal === "filter_assign_count" ? null : "filter_assign_count")}>
              <span className="ld-filter-btn-icon"><IconUser /></span>
              <span className="ld-filter-btn-text">
                {assignmentCountFilter === "All" ? "All Assignments" : `${assignmentCountFilter} Assignment(s)`}
              </span>
              <IconChevron up={modal === "filter_assign_count"} />
            </button>
            {modal === "filter_assign_count" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    {["All", ...Array.from({ length: maxAssignments + 1 }, (_, i) => String(i))].map(opt => (
                      <button key={opt} className={`ld-dropdown-item${assignmentCountFilter === opt ? " active" : ""}`} onClick={() => { setAssignmentCountFilter(opt); setModal(null); }}>
                        <input type="checkbox" checked={assignmentCountFilter === opt} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {opt === "All" ? "All Assignments" : opt === "0" ? "0 times" : opt === "1" ? "1 time" : `${opt} times`}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* First Assignee Filter */}
          <div className="ld-dropdown-wrap">
            <button className={`ld-filter-btn${firstAssigneeFilter.length > 0 ? " active" : ""}`} onClick={() => setModal(modal === "filter_first_assignee" ? null : "filter_first_assignee")}>
              <span className="ld-filter-btn-icon"><IconUser /></span>
              <span className="ld-filter-btn-text">
                {firstAssigneeFilter.length === 0 ? "All First Assignees" : `${firstAssigneeFilter.length} Selected`}
              </span>
              <IconChevron up={modal === "filter_first_assignee"} />
            </button>
            {modal === "filter_first_assignee" && (
              <>
                <div className="ld-dropdown-overlay" onClick={() => setModal(null)} />
                <div className="ld-dropdown-menu">
                  <div className="ld-dropdown-list">
                    <button className={`ld-dropdown-item${firstAssigneeFilter.length === 0 ? " active" : ""}`} onClick={() => { setFirstAssigneeFilter([]); }}>
                      <input type="checkbox" checked={firstAssigneeFilter.length === 0} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                      All First Assignees
                    </button>
                    {teamMembers.map(m => (
                      <button key={m.id} className={`ld-dropdown-item${firstAssigneeFilter.includes(String(m.id)) ? " active" : ""}`} onClick={() => {
                        const mid = String(m.id);
                        setFirstAssigneeFilter(prev => prev.includes(mid) ? prev.filter(x => x !== mid) : [...prev, mid]);
                      }}>
                        <input type="checkbox" checked={firstAssigneeFilter.includes(String(m.id))} readOnly style={{ marginRight: '8px', pointerEvents: 'none' }} />
                        {m.name}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="ld-date-filter-wrap" style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#fff', padding: '4px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', marginLeft: 'auto' }}>
          <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>Assigned:</span>
          <input
            type="date"
            value={assignedDateStart}
            onChange={e => setAssignedDateStart(e.target.value)}
            style={{ border: 'none', fontSize: '12px', color: '#1e293b', background: 'transparent', outline: 'none' }}
            title="Assignment Start Date"
          />
          <span style={{ color: '#cbd5e1' }}>—</span>
          <input
            type="date"
            value={assignedDateEnd}
            onChange={e => setAssignedDateEnd(e.target.value)}
            style={{ border: 'none', fontSize: '12px', color: '#1e293b', background: 'transparent', outline: 'none' }}
            title="Assignment End Date"
          />
          {(assignedDateStart || assignedDateEnd) && (
            <button
              onClick={() => { setAssignedDateStart(""); setAssignedDateEnd(""); }}
              style={{ border: 'none', background: 'transparent', color: '#ef4444', cursor: 'pointer', fontSize: '14px', padding: '0 4px' }}
              title="Clear Date Filter"
            >
              ✕
            </button>
          )}
        </div>
        <button className={`ld-source-toggle-btn${showSources ? " active" : ""}`} onClick={() => setShowSources(!showSources)} style={{ marginLeft: '8px' }}>
          <IconFilter /> Sources {showSources ? <IconChevron up /> : <IconChevron />}
          {activeSourceFilter !== "All" && <span className="ld-source-active-badge">1</span>}
        </button>
      </div>

      {showSources && (
        <div className="ld-source-bar">
          <div className="ld-source-analytics">
            <div className={`ld-source-analytics-card ld-sac-all ${activeSourceFilter === "All" ? "active" : ""}`} onClick={() => setActiveSourceFilter("All")}>
              <div className="ld-sac-top">
                <span className="ld-sac-icon"><IconChart /></span>
                <span className="ld-sac-pct">100%</span>
              </div>
              <div className="ld-sac-name">All Sources</div>
              <div className="ld-sac-count">{leads.length} leads</div>
              <div className="ld-sac-bar-wrap"><div className="ld-sac-bar-fill" style={{ width: '100%', background: '#9ca3af' }} /></div>
              <div className="ld-sac-value">₹{(leads.reduce((a, b) => a + parseInt(b.value || 0), 0) / 1000).toFixed(1)}k</div>
            </div>
            {dynamicSourceOptions.map(opt => {
              const srcLeads = leads.filter(l => l.source === opt.name);
              const count = srcLeads.length;
              const pct = leads.length ? Math.round((count / leads.length) * 100) : 0;
              const val = srcLeads.reduce((a, b) => a + parseInt(b.value || 0), 0);
              return (
                <div key={opt.name} className={`ld-source-analytics-card ${activeSourceFilter === opt.name ? "active" : ""}`}
                  onClick={() => setActiveSourceFilter(activeSourceFilter === opt.name ? "All" : opt.name)}
                  style={activeSourceFilter === opt.name ? { borderLeftColor: opt.color, borderLeftWidth: '3px' } : {}}
                >
                  <div className="ld-sac-top">
                    <span className="ld-sac-icon">{opt.icon}</span>
                    <span className="ld-sac-pct">{pct}%</span>
                  </div>
                  <div className="ld-sac-name">{opt.name}</div>
                  <div className="ld-sac-count">{count} leads</div>
                  <div className="ld-sac-bar-wrap"><div className="ld-sac-bar-fill" style={{ width: `${pct}%`, background: opt.color }} /></div>
                  <div className="ld-sac-value">₹{(val / 1000).toFixed(1)}k</div>
                </div>
              );
            })}
          </div>
          <div className="ld-source-pills">
            <span className="ld-source-pills-label">Quick Filters:</span>
            {["All", ...dynamicSourceOptions.map(o => o.name)].map(name => (
              <button key={name} className={`ld-source-pill${activeSourceFilter === name ? " active" : ""}`}
                onClick={() => setActiveSourceFilter(name)}
                style={activeSourceFilter === name ? { background: '#f2f7e4', borderColor: '#b0cc55', color: '#3d5c04' } : {}}
              >
                {name}
                <span className="ld-source-pill-count">{name === "All" ? leads.length : leads.filter(l => l.source === name).length}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="ld-table-card">
        <div className="ld-table-wrap">
          <table className="ld-table">
            <thead>
              <tr>
                {canBulk && (
                  <th style={{ width: '40px' }}>
                    <input
                      type="checkbox"
                      checked={leads.length > 0 && selectedLeadIds.length === leads.length}
                      onChange={toggleSelectAll}
                    />
                  </th>
                )}
                <th>Lead / University</th>
                <th>Contact info</th>
                <th>Source</th>
                <th>Status</th>
                <th>Sub Status</th>
                <th>Course</th>
                <th>Type</th>
                <th>Distribution</th>
                <th>Assign Count</th>
                <th style={{ textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {leads.length === 0 ? (
                <tr>
                  <td colSpan={canBulk ? "11" : "10"}>
                    <div className="ld-empty">
                      <div className="ld-empty-icon"><IconFolder size={48} style={{ color: '#cbd5e1', marginBottom: '12px' }} /></div>
                      <p className="ld-empty-text">No leads found</p>
                      <p className="ld-empty-sub">Try adjusting your filters or adding a new record.</p>
                    </div>
                  </td>
                </tr>
              ) : leads.map((lead, i) => {
                const sc = STATUS_CFG[lead.status] || STATUS_CFG.New;
                return (
                  <tr 
                    key={lead.id} 
                    id={`lead-row-${lead.id}`}
                    style={{ animationDelay: `${i * 0.05}s` }} 
                    className={`${selectedLeadIds.includes(lead.id) ? 'ld-row-selected' : ''} ${highlightedLeadId === lead.id ? 'ld-row-highlight' : ''}`}
                  >
                    {canBulk && (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedLeadIds.includes(lead.id)}
                          onChange={() => toggleSelectLead(lead.id)}
                        />
                      </td>
                    )}
                    <td>
                      <div className="ld-cell-user">
                        <div className="ld-avatar" style={{ background: AVATAR_COLORS[lead.id % 6][0], color: AVATAR_COLORS[lead.id % 6][1], position: 'relative' }}>
                          {lead.avatar}
                          {(() => {
                            const upcoming = lead.followups?.find(f => f.status === 'Scheduled' && isTodayFuture(f.scheduled_at));
                            return upcoming ? <div className="ld-alert-dot" title="Upcoming interaction today" /> : null;
                          })()}
                        </div>
                        <div>
                          <div className="ld-user-name" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span 
                              style={{ borderBottom: '1px dashed #799F0C', cursor: 'pointer' }}
                              onClick={() => openCombined(lead)}
                              title="Click to view & edit lead"
                            >
                              {lead.name}
                            </span>
                            {(() => {
                              const upcoming = lead.followups?.find(f => f.status === 'Scheduled' && isTodayFuture(f.scheduled_at));
                              const missed = lead.followups?.find(f => f.status === 'Scheduled' && new Date(f.scheduled_at) <= new Date());
                              if (missed) return <span className="ld-alert-mini-label" style={{ background: '#fef2f2', color: '#ef4444', borderColor: '#fee2e2' }}>Missed</span>;
                              return upcoming ? <span className="ld-alert-mini-label">Upcoming</span> : null;
                            })()}
                          </div>
                          <div className="ld-user-university">{lead.company}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="ld-contact-line">{lead.email}</div>
                      <div className="ld-contact-line" style={{ fontSize: "11px", opacity: 0.7 }}>{lead.phone || "No phone"}</div>
                    </td>
                    <td>
                      {(() => {
                        const opt = dynamicSourceOptions.find(o => o.name === lead.source) || { name: lead.source, icon: <IconStar />, color: "#6366f1" };
                        return (
                          <span className="ld-source-badge" style={{ background: opt.color + "15", color: opt.color }}>
                            <span className="ld-source-badge-icon">{opt.icon}</span> {lead.source}
                          </span>
                        );
                      })()}
                    </td>
                    <td>
                      <span className="ld-status" style={{ background: sc.bg, color: sc.color }}>
                        <div className="ld-status-dot" style={{ background: sc.dot }} />
                        {lead.status}
                      </span>
                    </td>
                    <td>
                      {(() => {
                        const ssc = SUB_STATUS_CFG[lead.sub_status] || { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' };
                        return lead.sub_status ? (
                          <span style={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: ssc.color,
                            background: ssc.bg,
                            padding: '2px 8px',
                            borderRadius: '100px',
                            border: `1px solid ${ssc.border}`,
                            whiteSpace: 'nowrap'
                          }}>
                            {lead.sub_status}
                          </span>
                        ) : (
                          <span style={{ color: '#cbd5e1' }}>—</span>
                        );
                      })()}
                    </td>
                    <td><span className="ld-value">{lead.course || "—"}</span></td>
                    <td>
                      <span style={{ 
                        fontSize: '11px', 
                        fontWeight: '600', 
                        color: '#6366f1', 
                        background: '#eef2ff', 
                        padding: '2px 8px', 
                        borderRadius: '100px',
                        border: '1px solid #e0e7ff'
                      }}>
                        {lead.lead_type_name || "—"}
                      </span>
                    </td>
                    <td>
                      {lead.assigned_to_name ? (
                        <div className="ld-assigned-chip" onClick={() => canAssign && openAssign(lead)} style={!canAssign ? { cursor: 'default' } : {}}>
                          <div className="ld-assigned-av" style={{ background: AVATAR_COLORS[lead.id % 6][0], color: AVATAR_COLORS[lead.id % 6][1] }}>
                            {initials(lead.assigned_to_name)}
                          </div>
                          <div className="ld-assigned-info">
                            <span className="ld-assigned-name">{lead.assigned_to_name}</span>
                            <span className="ld-assigned-role">
                              {lead.assigned_at ? `on ${new Date(lead.assigned_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}` : "Assigned"}
                            </span>
                          </div>
                          <div className="ld-assigned-status-dot" style={{ background: "#22c55e" }} />
                        </div>
                      ) : (
                        <button className="ld-unassigned-btn" onClick={() => canAssign && openAssign(lead)} style={!canAssign ? { opacity: 0.7, cursor: 'not-allowed' } : {}}>
                          <IconPlus style={{ marginRight: '4px' }} /> Assign
                        </button>
                      )}
                    </td>
                    <td>
                      <span className="ld-assign-count" style={{ fontSize: '13px', fontWeight: '500', color: '#64748b' }}>
                        {lead.assignment_count || 0} times
                      </span>
                    </td>
                    <td>
                      <div className="ld-actions">
                        {canAssign && (
                          <button className="ld-action-btn" title="Assign Lead" onClick={() => openAssign(lead)}>
                            <IconPlus />
                          </button>
                        )}
                        <button className="ld-action-btn" title="View Details" onClick={() => openView(lead)}>
                          <IconEye />
                        </button>
                        {canEdit && (
                          <button className="ld-action-btn" title="Edit" onClick={() => openEdit(lead)}>
                            <IconEdit />
                          </button>
                        )}
                        {canDelete && (
                          <button className="ld-action-btn danger" title="Delete" onClick={() => openDelete(lead)}>
                            <IconTrash />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {leads.length > 0 && (
          <div className="ld-pagination">
            <div className="ld-pagination-info">
              Showing <span>{(currentPage - 1) * pageSize + 1}</span> to <span>{Math.min(currentPage * pageSize, totalLeads)}</span> of <span>{totalLeads}</span> leads
            </div>
            <div className="ld-pagination-btns">
              <button
                className="ld-page-btn"
                disabled={currentPage === 1}
                onClick={() => fetchLeads(currentPage - 1)}
              >
                Previous
              </button>
              <div className="ld-page-size-selector">
                <span style={{ fontSize: '12px', color: '#64748b' }}>Show:</span>
                <select
                  value={pageSize}
                  onChange={(e) => {
                    const newSize = parseInt(e.target.value);
                    setPageSize(newSize);
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '4px 8px',
                    borderRadius: '6px',
                    border: '1px solid #e2e8f0',
                    fontSize: '12px',
                    color: '#1e293b',
                    fontWeight: '600',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={250}>250</option>
                  <option value={500}>500</option>
                  <option value={1000}>1000</option>
                </select>
              </div>
              {(() => {
                const totalPages = Math.ceil(totalLeads / pageSize);
                const pages = [];
                for (let i = 1; i <= totalPages; i++) {
                  if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
                    pages.push(
                      <button
                        key={i}
                        className={`ld-page-num${currentPage === i ? " active" : ""}`}
                        onClick={() => fetchLeads(i)}
                      >
                        {i}
                      </button>
                    );
                  } else if (i === currentPage - 2 || i === currentPage + 2) {
                    pages.push(<span key={i} className="ld-page-dots">...</span>);
                  }
                }
                return pages;
              })()}
              <button
                className="ld-page-btn"
                disabled={currentPage * pageSize >= totalLeads}
                onClick={() => fetchLeads(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Bulk Action Bar */}
      {selectedLeadIds.length > 0 && (
        <div className="ld-bulk-bar">
          <div className="ld-bulk-info">
            <span className="ld-bulk-count">{selectedLeadIds.length}</span> leads selected
          </div>
          <div className="ld-bulk-actions">
            {canBulkAssign && (
              <button className="ld-bulk-btn assign" onClick={openBulkAssign}>
                <IconPlus /> Bulk Assign
              </button>
            )}
            {canBulkDelete && (
              <button className="ld-bulk-btn delete" onClick={openBulkDelete}>
                <IconTrash /> Bulk Delete
              </button>
            )}
            <button className="ld-bulk-btn cancel" onClick={() => setSelectedLeadIds([])}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {(modal === "add" || modal === "edit") && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal">
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">CRM · {modal === "add" ? "New Record" : "Edit Record"}</p>
                <h2 className="ld-modal-title">{modal === "add" ? "Add Lead" : "Edit Lead"}</h2>
              </div>
              <button className="ld-modal-close" onClick={closeModal}>✕</button>
            </div>
            <FormFields form={form} setForm={setForm} errors={errors} setErrors={setErrors} leadTypes={leadTypes} setLeadTypes={setLeadTypes} sourceOptions={formSourceOptions} />
            <div className="ld-modal-foot">
              <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
              <button className="ld-btn-save" onClick={modal === "add" ? handleAdd : handleEdit}>
                <IconPlus /> {modal === "add" ? "Add Lead" : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {modal === "combined" && activeLead && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--xl">
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">CRM · Lead Profile & Timeline</p>
                <h2 className="ld-modal-title">Edit & View: {activeLead.name}</h2>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <button
                  className="ld-btn-save"
                  onClick={handleSaveEverything}
                  style={{
                    padding: '8px 18px',
                    fontSize: '13px',
                    background: '#799F0C',
                    border: 'none',
                    color: '#fff',
                    borderRadius: '8px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(121, 159, 12, 0.25)',
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  Save All
                </button>
                {activeLead.is_from_buffer && (
                  <button
                    className="ld-btn-cancel"
                    onClick={async () => {
                      if (window.confirm("Are you sure you want to delete this lead and send it back to the webhook staging buffer?")) {
                        try {
                          await api.post(`/crm/leads/${activeLead.id}/transfer-back-to-buffer/`);
                          showToast("Lead transferred back to buffer successfully!");
                          closeModal();
                          fetchLeads(currentPage);
                        } catch (err) {
                          showToast(err.response?.data?.error || "Failed to transfer lead back to buffer.");
                        }
                      }
                    }}
                    style={{
                      padding: '8px 18px',
                      fontSize: '13px',
                      background: '#fee2e2',
                      borderColor: '#fca5a5',
                      color: '#dc2626',
                      borderRadius: '8px',
                      fontWeight: 700,
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    ↩️ Transfer to Buffer
                  </button>
                )}
                <button className="ld-modal-close" onClick={closeModal} style={{ margin: 0 }}>✕</button>
              </div>
            </div>
            
            <div className="ld-modal-combined-body">
              {/* Left Column: Edit Details */}
              <div className="ld-modal-combined-left">
                <h3 style={{ fontSize: '13px', fontWeight: 800, marginBottom: '16px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                  Lead Information
                </h3>
                <FormFields form={form} setForm={setForm} errors={errors} setErrors={setErrors} leadTypes={leadTypes} setLeadTypes={setLeadTypes} sourceOptions={formSourceOptions} />
                {/* ORIGINAL ACTION BUTTONS (HIDDEN): Change display to 'flex' to show again */}
                <div style={{ display: 'none', justifyContent: 'flex-end', marginTop: '20px', gap: '8px', borderTop: '1px solid #f1f5f9', paddingTop: '16px' }}>
                  <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
                  <button className="ld-btn-save" onClick={handleEdit}>
                    Save Changes
                  </button>
                </div>
              </div>
 
              {/* Right Column: Timeline & Interactions */}
              <div className="ld-modal-combined-right">
                {(() => {
                  const imminent = activeLead.followups?.find(f => f.status === 'Scheduled' && isTodayFuture(f.scheduled_at));
                  if (!imminent) return null;
                  return (
                    <div className="ld-imminent-alert" style={{ marginBottom: '16px' }}>
                      <div className="ld-imminent-icon"><IconAlert /></div>
                      <div className="ld-imminent-content">
                        <strong>Action Required:</strong> Upcoming {imminent.followup_type} scheduled for {new Date(imminent.scheduled_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })} today.
                      </div>
                    </div>
                  );
                })()}
 
                {canLog(activeLead) ? (
                  <div className="ld-log-activity" style={{ background: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '20px' }}>
                    <h4 className="ld-log-title" style={{ fontSize: '13px', fontWeight: 700, marginBottom: '12px' }}>Log Interaction</h4>
                    <div className="ld-log-row">
                      <select className="ld-form-input" value={followupForm.type} onChange={e => setFollowupForm({ ...followupForm, type: e.target.value })}>
                        <option value="Call">Phone Call</option>
                        <option value="Email">Email</option>
                        <option value="Meeting">Meeting</option>
                        <option value="WhatsApp">WhatsApp</option>
                      </select>
                      <input type="datetime-local" className="ld-form-input" value={followupForm.scheduled_at} onChange={e => setFollowupForm({ ...followupForm, scheduled_at: e.target.value })} />
                    </div>
                    <div className="ld-log-row">
                      <select className="ld-form-input" value={followupForm.status} onChange={e => setFollowupForm({ ...followupForm, status: e.target.value })}>
                        <option value="Completed">Completed Activity</option>
                        <option value="Scheduled">Schedule for Later</option>
                      </select>
                    </div>
                    <div className="ld-log-row" style={{ marginTop: '10px' }}>
                      <div className="ld-form-field" style={{ flex: 1 }}>
                        <span className="ld-view-label">Update Sub Status</span>
                        <select
                          className="ld-form-input"
                          value={followupForm.sub_status}
                          onChange={e => setFollowupForm({ ...followupForm, sub_status: e.target.value })}
                        >
                          <option value="">Select sub status...</option>
                          {SUB_STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                        </select>
                        {followupForm.sub_status === "Other" && (
                          <input
                            className="ld-form-input"
                            style={{ marginTop: '8px' }}
                            placeholder="Type custom status..."
                            value={followupForm.custom_sub_status}
                            onChange={e => setFollowupForm({ ...followupForm, custom_sub_status: e.target.value })}
                          />
                        )}
                      </div>
                      {/* ORIGINAL LOG BUTTON (HIDDEN): Change display to 'flex' to show again */}
                      <div className="ld-form-field" style={{ flex: 1, display: 'none', alignItems: 'flex-end' }}>
                        <button
                          className="ld-add-btn"
                          style={{ width: '100%', justifyContent: 'center', opacity: isLogging ? 0.7 : 1, height: '38px' }}
                          onClick={handleLogFollowup}
                          disabled={isLogging}
                        >
                          {isLogging ? "Saving..." : "Save Interaction"}
                        </button>
                      </div>
                    </div>

                    {followupForm.status === 'Completed' && (
                      <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', fontWeight: 600, color: '#374151', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={followupForm.setNextFollowup}
                            onChange={e => setFollowupForm({ ...followupForm, setNextFollowup: e.target.checked })}
                            style={{ width: '14px', height: '14px' }}
                          />
                          Schedule a follow-up?
                        </label>
                        {followupForm.setNextFollowup && (
                          <div className="ld-form-field">
                            <span className="ld-view-label">Follow-up Date</span>
                            <input
                              type="datetime-local"
                              className="ld-form-input"
                              value={followupForm.nextFollowupDate}
                              onChange={e => setFollowupForm({ ...followupForm, nextFollowupDate: e.target.value })}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <textarea
                      className="ld-form-input ld-textarea"
                      placeholder="Brief notes about the conversation..."
                      style={{ fontSize: '12px', marginTop: '10px' }}
                      value={followupForm.notes}
                      onChange={e => setFollowupForm({ ...followupForm, notes: e.target.value })}
                    />
                  </div>
                ) : (
                  <div style={{ padding: '20px', background: '#f9fafb', borderRadius: '8px', border: '1px dashed #e5e7eb', textAlign: 'center', color: '#6b7280', fontSize: '13px', marginBottom: '20px' }}>
                    Interaction logging is restricted to the assigned representative or creator.
                  </div>
                )}

                <div className="ld-timeline-header-wrap" style={{ marginTop: '0px' }}>
                  <h4 className="ld-timeline-title">Interactions</h4>
                  <div className="ld-timeline-tabs">
                    <button className={`ld-timeline-tab ${timelineTab === "History" ? "active" : ""}`} onClick={() => setTimelineTab("History")}>Activity History</button>
                    <button className={`ld-timeline-tab ${timelineTab === "Upcoming" ? "active" : ""}`} onClick={() => setTimelineTab("Upcoming")}>Upcoming Schedule</button>
                    <button className={`ld-timeline-tab ${timelineTab === "Missed" ? "active" : ""}`} onClick={() => setTimelineTab("Missed")}>
                      Missed
                      {(() => {
                        const missedCount = (activeLead.followups || []).filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) <= new Date()).length;
                        return missedCount > 0 ? <span className="ld-tab-badge">{missedCount}</span> : null;
                      })()}
                    </button>
                  </div>
                </div>

                <div style={{ maxHeight: '430px', overflowY: 'auto', paddingLeft: '20px', paddingRight: '4px' }}>
                  <div className="ld-timeline">
                    {(() => {
                      const now = new Date();
                      const followups = activeLead.followups || [];
                      let list = [];
                      if (timelineTab === "History") {
                        list = followups.filter(f => f.status === 'Completed').sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
                      } else if (timelineTab === "Upcoming") {
                        list = followups.filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) > now).sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
                      } else if (timelineTab === "Missed") {
                        list = followups.filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) <= now).sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
                      }

                      if (list.length === 0) {
                        return <div className="ld-timeline-empty">{timelineTab === "History" ? "No past activities found." : "No upcoming interactions scheduled."}</div>;
                      }

                      return list.map(f => {
                        const isMissed = f.status === 'Scheduled' && new Date(f.scheduled_at) < new Date();
                        return (
                          <div key={f.id} className={`ld-timeline-item ${f.status === 'Scheduled' ? 'scheduled' : ''} ${isMissed ? 'missed' : ''}`}>
                            <div className="ld-timeline-icon" style={isMissed ? { background: '#fef2f2', border: '2px solid #ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {isMissed ? <IconAlert /> : (
                                <>
                                  {f.followup_type === 'Call' && <IconPhone />}
                                  {f.followup_type === 'Email' && <IconMail />}
                                  {f.followup_type === 'Meeting' && <IconHandshake />}
                                  {f.followup_type === 'WhatsApp' && <IconSmartphone />}
                                  {f.followup_type === 'Assignment' && <IconUser />}
                                  {f.followup_type === 'Other' && <IconStar />}
                                </>
                              )}
                            </div>
                            <div className="ld-timeline-hdr">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <strong>{f.followup_type === 'Assignment' ? 'Lead Distributed' : `${f.followup_type} ${f.status === 'Completed' ? 'Logged' : 'Scheduled'}`}</strong>
                                {isMissed && <span className="badge red" style={{ fontSize: '10px', padding: '2px 6px' }}>OVERDUE</span>}
                              </div>
                              <span style={isMissed ? { color: '#ef4444', fontWeight: 'bold' } : {}}>{new Date(f.scheduled_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                            </div>

                            {editingFollowupId === f.id ? (
                              <div className="ld-timeline-edit-mode">
                                <textarea
                                  className="ld-form-input ld-textarea"
                                  style={{ fontSize: '12px', minHeight: '60px' }}
                                  value={editNote}
                                  onChange={e => setEditNote(e.target.value)}
                                  autoFocus
                                />
                                <div className="ld-timeline-edit-btns">
                                  <button className="ld-btn-cancel sm" onClick={() => setEditingFollowupId(null)}>Cancel</button>
                                  <button className="ld-btn-save sm" onClick={() => handleUpdateFollowup(f.id, { notes: editNote })}>Save Note</button>
                                </div>
                              </div>
                            ) : (
                              <div className="ld-timeline-notes">
                                {f.notes || "No notes added."}
                                {f.call_log_details && (
                                  <div className="ld-timeline-call-mini">
                                    <span className="ld-mini-tag">Telephony</span>
                                    <span>{f.call_log_details.call_type} • {f.call_log_details.duration}s</span>
                                    {f.call_log_details.recording_url && (
                                      <a href={f.call_log_details.recording_url} target="_blank" rel="noreferrer" className="ld-recording-link">
                                        Play Recording
                                      </a>
                                    )}
                                  </div>
                                )}
                                {f.status === 'Scheduled' && (
                                  <button className="ld-timeline-edit-note-btn" onClick={() => { setEditingFollowupId(f.id); setEditNote(f.notes || ""); }}>
                                    Edit Note
                                  </button>
                                )}
                              </div>
                            )}
                            
                            <div className="ld-timeline-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span>By {f.followup_type === 'Assignment' ? 'System' : (f.created_by_name || 'System')}</span>
                              {f.status === 'Scheduled' && (
                                <button 
                                  className="ld-mark-done-btn" 
                                  onClick={() => handleUpdateFollowup(f.id, { status: 'Completed' })}
                                >
                                  Mark Done
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {modal === "view" && activeLead && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--view">
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">CRM · Lead Details</p>
                <h2 className="ld-modal-title">View Lead</h2>
              </div>
              <button className="ld-modal-close" onClick={closeModal}>✕</button>
            </div>
            <div className="ld-view-body">
              <div className="ld-view-hero">
                <div className="ld-view-avatar" style={{ background: AVATAR_COLORS[activeLead.id % 6][0], color: AVATAR_COLORS[activeLead.id % 6][1] }}>
                  {initials(activeLead.name)}
                </div>
                <div>
                  <h3 className="ld-view-name">{activeLead.name}</h3>
                  <p className="ld-view-university">{activeLead.company}</p>
                </div>
                <span className="ld-status" style={{
                  background: (STATUS_CFG[activeLead.status] || STATUS_CFG.New).bg,
                  color: (STATUS_CFG[activeLead.status] || STATUS_CFG.New).color,
                  marginLeft: "auto"
                }}>
                  <div className="ld-status-dot" style={{ background: (STATUS_CFG[activeLead.status] || STATUS_CFG.New).dot }} />
                  {activeLead.status}
                </span>
              </div>

              {(() => {
                const imminent = activeLead.followups?.find(f => f.status === 'Scheduled' && isTodayFuture(f.scheduled_at));
                if (!imminent) return null;
                return (
                  <div className="ld-imminent-alert">
                    <div className="ld-imminent-icon"><IconAlert /></div>
                    <div className="ld-imminent-content">
                      <strong>Action Required:</strong> Upcoming {imminent.followup_type} scheduled for {new Date(imminent.scheduled_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })} today.
                    </div>
                  </div>
                );
              })()}

              <div className="ld-view-grid">
                <div className="ld-view-item">
                  <span className="ld-view-label">Email</span>
                  <span className="ld-view-val">{activeLead.email || "—"}</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Phone</span>
                  <span className="ld-view-val">{activeLead.phone || "—"}</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Sub Status</span>
                  <span className="ld-view-val">
                    {(() => {
                      const ssc = SUB_STATUS_CFG[activeLead.sub_status] || { bg: '#f1f5f9', color: '#475569', border: '#e2e8f0' };
                      return activeLead.sub_status ? (
                        <span style={{
                          fontSize: '11px',
                          fontWeight: 600,
                          color: ssc.color,
                          background: ssc.bg,
                          padding: '2px 8px',
                          borderRadius: '100px',
                          border: `1px solid ${ssc.border}`
                        }}>
                          {activeLead.sub_status}
                        </span>
                      ) : "—";
                    })()}
                  </span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Course</span>
                  <span className="ld-view-val ld-view-val--green" style={{ color: '#059669' }}>{activeLead.course || "—"}</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">State</span>
                  <span className="ld-view-val">{activeLead.state || "—"}</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">District</span>
                  <span className="ld-view-val">{activeLead.district || "—"}</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Assigned To</span>
                  <span className="ld-view-val">
                    {activeLead.assigned_to_name || "Unassigned"}
                    {activeLead.assigned_at && ` (on ${new Date(activeLead.assigned_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })})`}
                  </span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Assignment Count</span>
                  <span className="ld-view-val">{activeLead.assignment_count || 0} times</span>
                </div>
                <div className="ld-view-item">
                  <span className="ld-view-label">Next Followup</span>
                  <span className="ld-view-val" style={{ color: '#799F0C' }}>
                    {activeLead.next_followup_date ? new Date(activeLead.next_followup_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : "Not scheduled"}
                  </span>
                </div>
                {activeLead.external_lead_id && (
                  <div className="ld-view-item">
                    <span className="ld-view-label">External ID ({activeLead.external_source || 'Ad Platform'})</span>
                    <span className="ld-view-val" style={{ fontFamily: 'monospace', fontSize: '11.5px', color: '#0f766e', background: '#f0fdf4', padding: '2px 6px', borderRadius: '4px', border: '1px solid #bbf7d0' }}>
                      {activeLead.external_lead_id}
                    </span>
                  </div>
                )}
              </div>

              {activeLead.notes && (
                <div className="ld-view-notes">
                  <span className="ld-view-label">Notes</span>
                  <p className="ld-view-notes-text">{activeLead.notes}</p>
                </div>
              )}

              <div className="ld-followup-section" style={{ marginTop: '20px', borderTop: '1px solid #f3f4f6', paddingTop: '20px' }}>
                {canLog(activeLead) ? (
                  <div className="ld-log-activity">
                    <h4 className="ld-log-title">Log Interaction</h4>
                    <div className="ld-log-row">
                      <select className="ld-form-input" value={followupForm.type} onChange={e => setFollowupForm({ ...followupForm, type: e.target.value })}>
                        <option value="Call">Phone Call</option>
                        <option value="Email">Email</option>
                        <option value="Meeting">Meeting</option>
                        <option value="WhatsApp">WhatsApp</option>
                      </select>
                      <input type="datetime-local" className="ld-form-input" value={followupForm.scheduled_at} onChange={e => setFollowupForm({ ...followupForm, scheduled_at: e.target.value })} />
                    </div>
                    <div className="ld-log-row">
                      <select className="ld-form-input" value={followupForm.status} onChange={e => setFollowupForm({ ...followupForm, status: e.target.value })}>
                        <option value="Completed">Completed Activity</option>
                        <option value="Scheduled">Schedule for Later</option>
                      </select>
                    </div>
                    <div className="ld-log-row" style={{ marginTop: '10px' }}>
                      <div className="ld-form-field" style={{ flex: 1 }}>
                        <span className="ld-view-label">Update Sub Status</span>
                        <select
                          className="ld-form-input"
                          value={followupForm.sub_status}
                          onChange={e => setFollowupForm({ ...followupForm, sub_status: e.target.value })}
                        >
                          <option value="">Select sub status...</option>
                          {SUB_STATUS_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                        </select>
                        {followupForm.sub_status === "Other" && (
                          <input
                            className="ld-form-input"
                            style={{ marginTop: '8px' }}
                            placeholder="Type custom status..."
                            value={followupForm.custom_sub_status}
                            onChange={e => setFollowupForm({ ...followupForm, custom_sub_status: e.target.value })}
                          />
                        )}
                      </div>
                      <div className="ld-form-field" style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          className="ld-add-btn"
                          style={{ width: '100%', justifyContent: 'center', opacity: isLogging ? 0.7 : 1, height: '38px' }}
                          onClick={handleLogFollowup}
                          disabled={isLogging}
                        >
                          {isLogging ? "Saving..." : "Save Interaction"}
                        </button>
                      </div>
                    </div>

                    {followupForm.status === 'Completed' && (
                      <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', fontWeight: 600, color: '#374151', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={followupForm.setNextFollowup}
                            onChange={e => setFollowupForm({ ...followupForm, setNextFollowup: e.target.checked })}
                            style={{ width: '14px', height: '14px' }}
                          />
                          Schedule a follow-up?
                        </label>
                        {followupForm.setNextFollowup && (
                          <div className="ld-form-field">
                            <span className="ld-view-label">Follow-up Date</span>
                            <input
                              type="datetime-local"
                              className="ld-form-input"
                              value={followupForm.nextFollowupDate}
                              onChange={e => setFollowupForm({ ...followupForm, nextFollowupDate: e.target.value })}
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <textarea
                      className="ld-form-input ld-textarea"
                      placeholder="Brief notes about the conversation..."
                      style={{ fontSize: '12px', marginTop: '10px' }}
                      value={followupForm.notes}
                      onChange={e => setFollowupForm({ ...followupForm, notes: e.target.value })}
                    />
                  </div>
                ) : (
                  <div style={{ padding: '20px', background: '#f9fafb', borderRadius: '8px', border: '1px dashed #e5e7eb', textAlign: 'center', color: '#6b7280', fontSize: '13px', marginBottom: '20px' }}>
                    Interaction logging is restricted to the assigned representative or creator.
                  </div>
                )}

                <div className="ld-timeline-header-wrap">
                  <h4 className="ld-timeline-title">Interactions</h4>
                  <div className="ld-timeline-tabs">
                    <button className={`ld-timeline-tab ${timelineTab === "History" ? "active" : ""}`} onClick={() => setTimelineTab("History")}>Activity History</button>
                    <button className={`ld-timeline-tab ${timelineTab === "Upcoming" ? "active" : ""}`} onClick={() => setTimelineTab("Upcoming")}>Upcoming Schedule</button>
                    <button className={`ld-timeline-tab ${timelineTab === "Missed" ? "active" : ""}`} onClick={() => setTimelineTab("Missed")}>
                      Missed
                      {(() => {
                        const missedCount = (activeLead.followups || []).filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) <= new Date()).length;
                        return missedCount > 0 ? <span className="ld-tab-badge">{missedCount}</span> : null;
                      })()}
                    </button>
                  </div>
                </div>

                {timelineTab === "History" && (
                  <div className="ld-interaction-summary" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '8px', marginBottom: '16px', padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                    {(() => {
                      const stats = (activeLead.followups || []).filter(f => f.status === 'Completed').reduce((acc, f) => {
                        if (f.followup_type === 'Call') {
                          if (f.call_log_details) acc.calls_callyzer++;
                          else acc.calls_manual++;
                        } else if (f.followup_type === 'Email') acc.emails++;
                        else if (f.followup_type === 'Meeting') acc.meetings++;
                        else if (f.followup_type === 'WhatsApp') acc.whatsapp++;
                        else if (f.followup_type === 'Assignment') acc.assignments++;
                        return acc;
                      }, { calls_manual: 0, calls_callyzer: 0, emails: 0, meetings: 0, whatsapp: 0, assignments: 0 });

                      return (
                        <>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1e293b' }}>{stats.calls_manual}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Manual Logs</div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#3b82f6' }}>{stats.calls_callyzer}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Calls Logs</div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#10b981' }}>{stats.whatsapp}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>WhatsApp</div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#8b5cf6' }}>{stats.emails}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Emails</div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#f59e0b' }}>{stats.meetings}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Meetings</div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#6366f1' }}>{stats.assignments}</div>
                            <div style={{ fontSize: '10px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Assignments</div>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}

                <div className="ld-timeline">
                  {(() => {
                    const now = new Date();
                    const followups = activeLead.followups || [];
                    let list = [];
                    if (timelineTab === "History") {
                      list = followups.filter(f => f.status === 'Completed').sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
                    } else if (timelineTab === "Upcoming") {
                      list = followups.filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) > now).sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
                    } else if (timelineTab === "Missed") {
                      list = followups.filter(f => f.status === 'Scheduled' && new Date(f.scheduled_at) <= now).sort((a, b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
                    }

                    if (list.length === 0) {
                      return <div className="ld-timeline-empty">{timelineTab === "History" ? "No past activities found." : "No upcoming interactions scheduled."}</div>;
                    }

                    return list.map(f => {
                      const isMissed = f.status === 'Scheduled' && new Date(f.scheduled_at) < new Date();
                      return (
                        <div key={f.id} className={`ld-timeline-item ${f.status === 'Scheduled' ? 'scheduled' : ''} ${isMissed ? 'missed' : ''}`}>
                          <div className="ld-timeline-icon" style={isMissed ? { background: '#fef2f2', border: '2px solid #ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {isMissed ? <IconAlert /> : (
                              <>
                                {f.followup_type === 'Call' && <IconPhone />}
                                {f.followup_type === 'Email' && <IconMail />}
                                {f.followup_type === 'Meeting' && <IconHandshake />}
                                {f.followup_type === 'WhatsApp' && <IconSmartphone />}
                                {f.followup_type === 'Assignment' && <IconUser />}
                                {f.followup_type === 'Other' && <IconStar />}
                              </>
                            )}
                          </div>
                          <div className="ld-timeline-hdr">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <strong>{f.followup_type === 'Assignment' ? 'Lead Distributed' : `${f.followup_type} ${f.status === 'Completed' ? 'Logged' : 'Scheduled'}`}</strong>
                              {isMissed && <span className="badge red" style={{ fontSize: '10px', padding: '2px 6px' }}>OVERDUE</span>}
                            </div>
                            <span style={isMissed ? { color: '#ef4444', fontWeight: 'bold' } : {}}>{new Date(f.scheduled_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                          </div>

                          {editingFollowupId === f.id ? (
                            <div className="ld-timeline-edit-mode">
                              <textarea
                                className="ld-form-input ld-textarea"
                                style={{ fontSize: '12px', minHeight: '60px' }}
                                value={editNote}
                                onChange={e => setEditNote(e.target.value)}
                                autoFocus
                              />
                              <div className="ld-timeline-edit-btns">
                                <button className="ld-btn-cancel sm" onClick={() => setEditingFollowupId(null)}>Cancel</button>
                                <button className="ld-btn-save sm" onClick={() => handleUpdateFollowup(f.id, { notes: editNote })}>Save Note</button>
                              </div>
                            </div>
                          ) : (
                            <div className="ld-timeline-notes">
                              {f.notes || "No notes added."}
                              {f.call_log_details && (
                                <div className="ld-timeline-call-mini">
                                  <span className="ld-mini-tag">Telephony</span>
                                  <span>{f.call_log_details.call_type} • {f.call_log_details.duration}s</span>
                                  {f.call_log_details.recording_url && (
                                    <a href={f.call_log_details.recording_url} target="_blank" rel="noreferrer" className="ld-recording-link">
                                      Play Recording
                                    </a>
                                  )}
                                </div>
                              )}
                              {f.status === 'Scheduled' && (
                                <button className="ld-timeline-edit-note-btn" onClick={() => { setEditingFollowupId(f.id); setEditNote(f.notes || ""); }}>
                                  Edit Note
                                </button>
                              )}
                            </div>
                          )}
                          
                          <div className="ld-timeline-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>By {f.followup_type === 'Assignment' ? 'System' : (f.created_by_name || 'System')}</span>
                            {f.status === 'Scheduled' && (
                              <button 
                                className="ld-mark-done-btn" 
                                onClick={() => handleUpdateFollowup(f.id, { status: 'Completed' })}
                              >
                                Mark Done
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>
            </div>
            <div className="ld-modal-foot">
              <button className="ld-btn-cancel" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {modal === "assign" && activeLead && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--assign">
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">CRM · Work Distribution</p>
                <h2 className="ld-modal-title">Assign Lead</h2>
              </div>
              <button className="ld-modal-close" onClick={closeModal}>✕</button>
            </div>
            <div className="ld-assign-lead-preview">
              <div className="ld-assign-lead-info">
                <div className="ld-assign-lead-av" style={{ background: AVATAR_COLORS[0][0], color: AVATAR_COLORS[0][1] }}>{initials(activeLead.name)}</div>
                <div>
                  <div className="ld-assign-lead-name">{activeLead.name}</div>
                  <div className="ld-assign-lead-university">{activeLead.company}</div>
                </div>
              </div>
              {activeLead.assigned_to_name && (
                <div className="ld-assign-current">
                  Currently assigned to: <strong>{activeLead.assigned_to_name}</strong>
                </div>
              )}
            </div>

            <div className="ld-assign-toolbar">
              <div className="ld-search-wrap" style={{ minWidth: '150px' }}>
                <div className="ld-search-icon"><IconSearch /></div>
                <input className="ld-search" placeholder="Search members…"
                  value={memberSearch} onChange={e => setMemberSearch(e.target.value)} />
              </div>
              <select className="ld-assign-dept-filter" value={deptFilter} onChange={e => setDeptFilter(e.target.value)}>
                <option value="All">All Departments</option>
                <option value="Sales">Sales</option>
                <option value="Marketing">Marketing</option>
                <option value="Operations">Operations</option>
              </select>
            </div>

            <div className="ld-assign-members-list">
              {teamMembers
                .filter(m => (m.name.toLowerCase().includes(memberSearch.toLowerCase())) && (deptFilter === "All" || m.department === deptFilter))
                .map(m => (
                  <div key={m.id}
                    className={`ld-member-row ${activeLead.assigned_to === m.id ? 'selected' : ''}`}
                    onClick={() => handleAssign(m.id)}
                  >
                    <div className="ld-member-row-av-wrap">
                      <div className="ld-member-row-av" style={{ background: AVATAR_COLORS[m.id % 6][0], color: AVATAR_COLORS[m.id % 6][1] }}>
                        {initials(m.name)}
                      </div>
                      <div className="ld-member-online-dot" style={{ background: "#22c55e" }} />
                    </div>
                    <div className="ld-member-row-info">
                      <div className="ld-member-row-name">{m.name}</div>
                      <div className="ld-member-row-meta">
                        <span>{m.designation || "Staff"}</span>
                        <span>•</span>
                        <span>{m.department || "General"}</span>
                      </div>
                    </div>
                    <div className="ld-member-row-right">
                      <div className="ld-member-load">
                        <span>{m.load} leads</span>
                      </div>
                      <div className="ld-member-perf">
                        <div className="ld-perf-bar"><div className="ld-perf-fill" style={{ width: `${m.performance}%`, background: '#b0cc55' }} /></div>
                        <span>{m.performance}%</span>
                      </div>
                    </div>
                    <div className={`ld-member-check ${activeLead.assigned_to === m.id ? 'checked' : ''}`}>
                      {activeLead.assigned_to === m.id ? '✓' : ''}
                    </div>
                  </div>
                ))}
              {teamMembers.length === 0 && <div className="ld-assign-empty"><p>No members found</p></div>}
            </div>
            <div className="ld-assign-footer-strip">
              <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
              {activeLead.assigned_to && canAssign && (
                <button className="ld-unassign-btn" onClick={() => handleAssign(null)}>Unassign Lead</button>
              )}
            </div>
          </div>
        </div>
      )}

      {modal === "delete" && activeLead && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--delete">
            <div className="ld-delete-icon-wrap">
              <div className="ld-delete-icon"><IconTrash size={32} /></div>
            </div>
            <div className="ld-delete-body">
              <h2 className="ld-delete-title">Delete Lead?</h2>
              <p className="ld-delete-sub">
                You're about to permanently delete <strong>{activeLead.name}</strong> from university <strong>{activeLead.company}</strong>.
                This action cannot be undone.
              </p>
            </div>
            <div className="ld-modal-foot ld-modal-foot--center">
              <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
              <button className="ld-btn-delete" onClick={handleDelete}>
                <IconTrash /> Delete Lead
              </button>
            </div>
          </div>
        </div>
      )}

      {showPreview && (
        <div className="ld-modal-backdrop">
          <div className="preview-modal" style={{ width: '850px', maxWidth: '95%' }}>
            <div className="preview-header">
              <div>
                <h2>Import Lead Preview</h2>
                <p>{previewData.length} records found in file</p>
              </div>
              <button className="close-btn" onClick={() => setShowPreview(false)}>✕</button>
            </div>
            <div className="preview-stats">
              <div className="stat-card valid">
                <span>{previewData.filter(l => !l.isDuplicate && !l.isInvalid).length}</span>
                <p>New / Valid</p>
              </div>
              <div className="stat-card duplicate">
                <span>{previewData.filter(l => l.isDuplicate).length}</span>
                <p>Duplicates Found</p>
              </div>
              <div className="stat-card invalid" style={{ background: '#fef2f2', borderColor: '#fecaca' }}>
                <span style={{ color: '#b91c1c' }}>{previewData.filter(l => l.isInvalid).length}</span>
                <p style={{ color: '#991b1b' }}>Invalid Rows</p>
              </div>
            </div>

            <div className="preview-list">
              {previewData.length > 100 && (
                <div style={{ padding: '8px 16px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontSize: '12px', color: '#64748b', textAlign: 'center' }}>
                  Showing first 100 of {previewData.length} records. All valid records will still be processed.
                </div>
              )}
              {previewData.slice(0, 100).map((l, i) => (
                <div key={i} className={`preview-item ${l.isDuplicate || l.isInvalid ? "dup" : ""}`}>
                  <div>
                    <strong>{l.name}</strong>
                    <p>{l.email} {l.phone ? `· ${l.phone}` : ""}</p>
                    {l.isInvalid && (
                      <p style={{ fontSize: '10px', color: '#ef4444', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <IconAlert size={12} style={{ margin: 0, color: '#ef4444' }} /> Invalid 10-digit number
                      </p>
                    )}
                    <p style={{ fontSize: '11px', color: '#64748b' }}>
                      {l.state}{l.district ? `, ${l.district}` : ""} {l.course ? `· ${l.course}` : ""}
                    </p>
                  </div>
                  {l.isDuplicate ? (
                    <span className="badge red">Duplicate</span>
                  ) : l.isInvalid ? (
                    <span className="badge red">Invalid</span>
                  ) : (
                    <span className="badge green">Valid</span>
                  )}
                </div>
              ))}
            </div>
            <div className="preview-footer" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end', padding: '14px 16px', background: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
              <button 
                className="btn cancel" 
                onClick={() => setShowPreview(false)}
                disabled={isImporting}
                style={{ padding: '8px 14px', fontSize: '12.5px', borderRadius: '6px', background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', cursor: 'pointer', fontWeight: 600 }}
              >
                Cancel
              </button>
              
              {(() => {
                const handleActionClick = async (action) => {
                  if (isImporting) return;
                  setIsImporting(true);
                  let finalLeadType = importLeadType;
                  if (importLeadType === "Other" && importCustomLeadType) {
                    try {
                      const res = await api.post('crm/lead-types/', { name: importCustomLeadType });
                      setLeadTypes(prev => [...prev, res.data]);
                      finalLeadType = res.data.id;
                    } catch (err) {
                      showToast("Failed to create new lead type");
                      setIsImporting(false);
                      return;
                    }
                  }

                  let targetLeads = previewData.filter(l => !l.isInvalid);
                  if (action === 'skip') {
                    targetLeads = targetLeads.filter(l => !l.isDuplicate);
                  }

                  if (targetLeads.length === 0) {
                    showToast("No valid leads to import for selected mode.");
                    setIsImporting(false);
                    return;
                  }

                  setImportProgress({ current: 0, total: targetLeads.length });
                  const batchSize = 100;
                  let successfullyImportedCount = 0;

                  try {
                    for (let i = 0; i < targetLeads.length; i += batchSize) {
                      const batch = targetLeads.slice(i, i + batchSize);
                      const res = await api.post("/crm/leads/bulk_create/", {
                        leads: batch.map(l => ({
                          first_name: l.first_name,
                          last_name: l.last_name,
                          email: l.email,
                          phone: l.phone,
                          company: l.company,
                          status: l.status || "New",
                          sub_status: l.sub_status,
                          course: l.course,
                          state: l.state,
                          district: l.district,
                          source: l.source,
                          lead_type: finalLeadType,
                          notes: l.notes || "",
                          alternate_contacts: l.alternate_contacts || []
                        })),
                        duplicate_action: action
                      });

                      if (res.data) {
                        successfullyImportedCount += res.data.length;
                      }
                      setImportProgress({ current: Math.min(i + batch.length, targetLeads.length), total: targetLeads.length });
                    }

                    fetchLeads(currentPage);
                    setShowPreview(false);
                    showToast(`${successfullyImportedCount} leads processed successfully (${action} mode)`);
                  } catch (err) {
                    showToast(`Import failed after processing ${successfullyImportedCount} leads.`);
                    console.error(err);
                    fetchLeads(currentPage);
                  } finally {
                    setIsImporting(false);
                  }
                };

                const validCount = previewData.filter(l => !l.isDuplicate && !l.isInvalid).length;
                const totalNonInvalid = previewData.filter(l => !l.isInvalid).length;

                return (
                  <>
                    <button
                      className="btn import"
                      disabled={isImporting || validCount === 0}
                      onClick={() => handleActionClick('skip')}
                      style={{ padding: '8px 14px', fontSize: '12.5px', borderRadius: '6px', background: '#2563eb', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, opacity: (isImporting || validCount === 0) ? 0.6 : 1 }}
                      title="Import only new leads; ignore duplicates"
                    >
                      Import Valid Only ({validCount})
                    </button>

                    <button
                      className="btn import"
                      disabled={isImporting || totalNonInvalid === 0}
                      onClick={() => handleActionClick('merge')}
                      style={{ padding: '8px 14px', fontSize: '12.5px', borderRadius: '6px', background: '#16a34a', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, opacity: (isImporting || totalNonInvalid === 0) ? 0.6 : 1 }}
                      title="Append notes, update missing fields & save alternate contacts onto existing leads"
                    >
                      Merge Duplicates ({totalNonInvalid})
                    </button>

                    <button
                      className="btn import"
                      disabled={isImporting || totalNonInvalid === 0}
                      onClick={() => handleActionClick('overwrite')}
                      style={{ padding: '8px 14px', fontSize: '12.5px', borderRadius: '6px', background: '#d97706', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, opacity: (isImporting || totalNonInvalid === 0) ? 0.6 : 1 }}
                      title="Update existing lead details with CSV values"
                    >
                      Overwrite Existing ({totalNonInvalid})
                    </button>

                    <button
                      className="btn import"
                      disabled={isImporting || totalNonInvalid === 0}
                      onClick={() => handleActionClick('force_create')}
                      style={{ padding: '8px 14px', fontSize: '12.5px', borderRadius: '6px', background: '#64748b', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, opacity: (isImporting || totalNonInvalid === 0) ? 0.6 : 1 }}
                      title="Create separate lead cards for all valid rows"
                    >
                      Force Create All ({totalNonInvalid})
                    </button>
                  </>
                );
              })()}
            </div>
            {isImporting && (
              <div className="preview-loading-overlay" style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255, 255, 255, 0.85)',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                zIndex: 10,
                borderRadius: '8px'
              }}>
                <div className="ld-spinner" style={{
                  width: '40px', height: '40px',
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #b0cc55',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  marginBottom: '16px'
                }} />
                <style>{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}</style>
                <strong style={{ color: '#1e293b', fontSize: '15px' }}>
                  Importing Leads... ({importProgress.current} / {importProgress.total})
                </strong>
                <p style={{ fontSize: '12px', color: '#64748b', marginTop: '6px' }}>
                  Uploading and validation in progress ({importProgress.total > 0 ? Math.round((importProgress.current / importProgress.total) * 100) : 0}%). Please do not close or refresh this page.
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {showFormatModal && (
        <div className="ld-modal-backdrop" onClick={() => setShowFormatModal(false)}>
          <div className="ld-modal" style={{ maxWidth: '600px' }} onClick={e => e.stopPropagation()}>
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">HELP · IMPORT FORMAT</p>
                <h2 className="ld-modal-title">Lead Import Guide</h2>
              </div>
              <button className="ld-modal-close" onClick={() => setShowFormatModal(false)}>✕</button>
            </div>
            <div className="ld-modal-body" style={{ padding: '20px' }}>
              {/* Upload Button at the top */}
              <div style={{ marginBottom: '20px', padding: '15px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                <h4 style={{ color: '#1e40af', fontSize: '14px', marginBottom: '8px' }}>Ready to Import?</h4>

                {/* Lead Type Selection */}
                <div style={{ marginBottom: '15px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 800, color: '#1e40af', display: 'block', marginBottom: '6px', textTransform: 'uppercase' }}>
                    Assign Lead Type to Imported Records
                  </label>
                  <select
                    className="ld-form-input"
                    style={{ background: '#fff', borderColor: '#bfdbfe' }}
                    value={importLeadType || ""}
                    onChange={e => setImportLeadType(e.target.value || null)}
                  >
                    <option value="">No Lead Type</option>
                    {leadTypes.map(lt => <option key={lt.id} value={lt.id}>{lt.name}</option>)}
                    <option value="Other">Other (Create New...)</option>
                  </select>
                  {importLeadType === "Other" && (
                    <input
                      type="text"
                      className="ld-form-input"
                      placeholder="Enter new lead type name..."
                      style={{ marginTop: '8px', background: '#fff', borderColor: '#bfdbfe' }}
                      value={importCustomLeadType}
                      onChange={e => setImportCustomLeadType(e.target.value)}
                    />
                  )}
                </div>

                <p style={{ fontSize: '12px', color: '#1e3a8a', marginBottom: '12px', fontWeight: 500 }}>
                  Select your CSV file to preview and import leads.
                </p>
                <button className="ld-add-btn" style={{ width: '100%' }} onClick={() => fileRef.current.click()}>
                  <IconUpload /> Select CSV or Excel File
                </button>
              </div>

              <p style={{ marginBottom: '15px', color: '#475569', fontSize: '14px' }}>
                Ensure your CSV file has the following column headers. The order doesn't matter, but the <strong>names must match</strong> exactly.
              </p>
              <div className="ld-format-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                {[
                  { h: "first_name", d: "First name of the student (Required)" },
                  { h: "last_name", d: "Last name or surname" },
                  { h: "email", d: "Email address (for duplicates check)" },
                  { h: "phone", d: "Mobile number" },
                  { h: "university", d: "University name (e.g. Delhi University)" },
                  { h: "course", d: "Course interested in (e.g. MBA)" },
                  { h: "state", d: "State of residence (e.g. Maharashtra)" },
                  { h: "district", d: "District or city (e.g. Mumbai)" },
                  { h: "source", d: "Website, Referral, Cold Call, etc." },
                  { h: "status", d: "New, Contacted, Interested, etc." },
                  { h: "sub_status", d: "Interested, Not Picking Up, etc." },
                  { h: "notes", d: "Additional remarks" },
                ].map(item => (
                  <div key={item.h} style={{ background: '#f8fafc', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                    <code style={{ color: '#0f172a', fontWeight: 'bold' }}>{item.h}</code>
                    <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>{item.d}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="ld-modal-foot">
              <button className="ld-btn-cancel" onClick={() => setShowFormatModal(false)}>Close Guide</button>
            </div>
          </div>
        </div>
      )}
      {modal === "bulk_assign" && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--assign">
            <div className="ld-modal-head">
              <div>
                <p className="ld-modal-eyebrow">CRM · Bulk Operations</p>
                <h2 className="ld-modal-title">Bulk Assign leads</h2>
                <p style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>Assigning {selectedLeadIds.length} leads to a team member</p>
              </div>
              <button className="ld-modal-close" onClick={closeModal}>✕</button>
            </div>

            <div className="ld-assign-toolbar">
              <div className="ld-search-wrap" style={{ minWidth: '150px' }}>
                <div className="ld-search-icon"><IconSearch /></div>
                <input className="ld-search" placeholder="Search members…"
                  value={memberSearch} onChange={e => setMemberSearch(e.target.value)} />
              </div>
            </div>

            <div className="ld-assign-members-list">
              {teamMembers
                .filter(m => (m.name.toLowerCase().includes(memberSearch.toLowerCase())) && (deptFilter === "All" || m.department === deptFilter))
                .map(m => (
                  <div key={m.id} className="ld-member-row" onClick={() => handleBulkAssign(m.id)}>
                    <div className="ld-member-row-av-wrap">
                      <div className="ld-member-row-av" style={{ background: AVATAR_COLORS[m.id % 6][0], color: AVATAR_COLORS[m.id % 6][1] }}>
                        {initials(m.name)}
                      </div>
                    </div>
                    <div className="ld-member-row-info">
                      <div className="ld-member-row-name">{m.name}</div>
                      <div className="ld-member-row-meta">
                        <span>{m.designation || "Staff"}</span>
                      </div>
                    </div>
                    <div className="ld-member-row-right">
                      <div className="ld-member-load"><span>{m.load} leads</span></div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="ld-assign-footer-strip">
              <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {modal === "bulk_delete" && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && closeModal()}>
          <div className="ld-modal ld-modal--delete">
            <div className="ld-delete-icon-wrap">
              <div className="ld-delete-icon"><IconAlert size={32} style={{ marginRight: 0, color: '#ef4444' }} /></div>
            </div>
            <div className="ld-delete-body">
              <h2 className="ld-delete-title">Bulk Delete Leads?</h2>
              <p className="ld-delete-sub">
                You're about to permanently delete <strong>{selectedLeadIds.length} leads</strong>.
                This action is irreversible and will remove all interaction history for these leads.
              </p>
            </div>
            <div className="ld-modal-foot ld-modal-foot--center">
              <button className="ld-btn-cancel" onClick={closeModal}>Cancel</button>
              <button className="ld-btn-delete" onClick={handleBulkDelete} disabled={isBulkProcessing}>
                {isBulkProcessing ? "Deleting..." : "Confirm Bulk Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* WEBHOOK LEAD BUFFER MODAL */}
      {showBufferModal && (
        <div className="ld-modal-backdrop" onClick={e => e.target === e.currentTarget && setShowBufferModal(false)}>
          <div className="ld-modal" style={{ width: '900px', maxWidth: '95%' }}>
            <div className="ld-modal-header">
              <h2 className="ld-modal-title">
                <i className="fa-solid fa-list-check" style={{ marginRight: 8, color: '#799F0C' }} />
                Webhook Lead Buffer (Staged Duplicates)
              </h2>
              <button className="ld-modal-close" onClick={() => setShowBufferModal(false)}>✕</button>
            </div>
            
            <div style={{ padding: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>
                  The staging buffer holds leads transferred via webhooks that match an existing record's email or phone number.
                </p>
                <button 
                  onClick={fetchBufferLeads} 
                  className="ld-io-btn"
                  style={{ padding: '6px 12px', fontSize: '12px' }}
                >
                  Refresh Buffer
                </button>
              </div>

              {bufferLoading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                  <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: 8, fontSize: '20px' }} /> Loading staging buffer...
                </div>
              ) : bufferLeads.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8', fontSize: '14px', background: '#f8fafc', borderRadius: '8px', border: '1px dashed #cbd5e1' }}>
                  🎉 No pending duplicate leads in staging. All inbound webhook leads are clean and routed!
                </div>
              ) : (
                <div style={{ overflowX: 'auto', border: '1px solid #cbd5e1', borderRadius: '8px', maxHeight: '400px' }}>
                  <table className="ld-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8fafc', borderBottom: '1px solid #cbd5e1' }}>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Lead Name</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Contact Info</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Source & Course</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Webhook Origin</th>
                        <th style={{ padding: '12px', textAlign: 'right' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bufferLeads.map((l) => (
                        <tr key={l.id} style={{ borderBottom: '1px solid #cbd5e1' }}>
                          <td style={{ padding: '12px', fontWeight: 'bold' }}>{l.first_name} {l.last_name}</td>
                          <td style={{ padding: '12px' }}>
                            <div>📞 {l.phone}</div>
                            {l.email && <div style={{ fontSize: '11px', color: '#64748b' }}>✉️ {l.email}</div>}
                          </td>
                          <td style={{ padding: '12px' }}>
                            <span style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: 'bold' }}>
                              {l.course || 'N/A'}
                            </span>
                            <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '4px' }}>Src: {l.external_source || 'Webhook'}</div>
                          </td>
                          <td style={{ padding: '12px', color: '#64748b', fontSize: '12px' }}>
                            {l.webhook_name}
                          </td>
                          <td style={{ padding: '12px', textAlign: 'right', display: 'flex', gap: '6px', justifyContent: 'flex-end' }}>
                            <button
                              onClick={() => handleTransfer(l.id, 'merge')}
                              style={{ padding: '4px 10px', fontSize: '11px', background: '#799F0C', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
                              title="Append webhook notes/extension data to the existing primary lead"
                            >
                              Merge
                            </button>
                            <button
                              onClick={() => handleTransfer(l.id, 'create')}
                              style={{ padding: '4px 10px', fontSize: '11px', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '4px', cursor: 'pointer' }}
                              title="Force create a separate new lead card"
                            >
                              Force Create
                            </button>
                            <button
                              onClick={() => setEditBufferLead(l)}
                              style={{ padding: '4px 8px', fontSize: '11px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: '4px', cursor: 'pointer' }}
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleIgnore(l.id)}
                              style={{ padding: '4px 8px', fontSize: '11px', background: '#fef2f2', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: '4px', cursor: 'pointer' }}
                            >
                              Ignore
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="ld-modal-footer">
              <button className="ld-btn-cancel" onClick={() => setShowBufferModal(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* QUICK EDIT WEBHOOK BUFFER ENTRY MODAL */}
      {editBufferLead && (
        <div className="ld-modal-backdrop" style={{ zIndex: 1100 }} onClick={e => e.target === e.currentTarget && setEditBufferLead(null)}>
          <div className="ld-modal" style={{ width: '500px' }}>
            <div className="ld-modal-header">
              <h2 className="ld-modal-title">📝 Edit Buffered Lead</h2>
              <button className="ld-modal-close" onClick={() => setEditBufferLead(null)}>✕</button>
            </div>
            <form onSubmit={handleSaveEdit}>
              <div className="ld-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '20px' }}>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>First Name</label>
                    <input
                      className="ld-form-input"
                      type="text"
                      value={editBufferLead.first_name || ''}
                      onChange={e => setEditBufferLead({ ...editBufferLead, first_name: e.target.value })}
                      style={{ width: '100%', marginTop: '4px' }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Last Name</label>
                    <input
                      className="ld-form-input"
                      type="text"
                      value={editBufferLead.last_name || ''}
                      onChange={e => setEditBufferLead({ ...editBufferLead, last_name: e.target.value })}
                      style={{ width: '100%', marginTop: '4px' }}
                    />
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Phone Number</label>
                  <input
                    className="ld-form-input"
                    type="text"
                    value={editBufferLead.phone || ''}
                    onChange={e => setEditBufferLead({ ...editBufferLead, phone: e.target.value })}
                    style={{ width: '100%', marginTop: '4px' }}
                    required
                  />
                </div>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Email Address</label>
                  <input
                    className="ld-form-input"
                    type="email"
                    value={editBufferLead.email || ''}
                    onChange={e => setEditBufferLead({ ...editBufferLead, email: e.target.value })}
                    style={{ width: '100%', marginTop: '4px' }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Course / Applied Program</label>
                  <input
                    className="ld-form-input"
                    type="text"
                    value={editBufferLead.course || ''}
                    onChange={e => setEditBufferLead({ ...editBufferLead, course: e.target.value })}
                    style={{ width: '100%', marginTop: '4px' }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: 'bold' }}>Notes</label>
                  <textarea
                    className="ld-form-input"
                    value={editBufferLead.notes || ''}
                    onChange={e => setEditBufferLead({ ...editBufferLead, notes: e.target.value })}
                    style={{ width: '100%', marginTop: '4px', minHeight: '80px', fontFamily: 'inherit' }}
                  />
                </div>
              </div>
              <div className="ld-modal-footer">
                <button type="button" className="ld-btn-cancel" onClick={() => setEditBufferLead(null)}>Cancel</button>
                <button type="submit" className="ld-add-btn" style={{ background: '#799F0C' }}>Save Changes</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function IconChevron({ up }) { return <svg style={up ? { transform: 'rotate(180deg)' } : {}} width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>; }
function IconPlus({ size = 13, style = {} }) { return <svg style={{ display: 'inline-block', verticalAlign: 'middle', ...style }} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>; }
function IconUpload() { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>; }
function IconDownload() { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>; }
function IconSearch() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>; }
function IconFilter() { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>; }
function IconEye() { return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>; }
function IconEdit({ size = 13 }) { return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>; }
function IconTrash({ size = 13 }) { return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" /></svg>; }